<template>
  <BaseTemplate v-if="!isKioskMode" app-name="" page-title="">
    <template #content>
      <div
        class="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-800 p-4 transition-all duration-300">
        <div class="mb-6">
          <!-- Barra de Filtros Horizontal -->
          <div v-if="!isKioskMode && (currentView === 'overview')"
            class="w-full bg-white/80 dark:bg-black/10 backdrop-blur-md dark:backdrop-blur-xl border border-gray-200 dark:border-white/5 rounded-lg p-4 mb-6 shadow-lg shadow-black/20">
            <div class="flex flex-wrap items-center gap-3">
              <!-- Botão Filtrar Período -->
              <button @click="openDateFilterModal" :class="[
                'px-4 py-2 rounded-lg transition-all duration-200 flex items-center gap-2 font-medium whitespace-nowrap backdrop-blur-sm dark:backdrop-blur-lg',
                isDateFilterActive
                  ? 'bg-blue-600 hover:bg-blue-700 text-white shadow-lg'
                  : 'bg-white/60 dark:bg-white/5 hover:bg-white/80 dark:hover:bg-white/10 text-gray-900 dark:text-white border border-gray-300 dark:border-white/10 backdrop-blur-sm dark:backdrop-blur-lg'
              ]">
                <Filter class="w-5 h-5 text-gray-900 dark:text-white" />
                <span>Período</span>
              </button>

              <!-- Botão Limpar Filtros -->
              <button @click="clearFilters"
                class="px-4 py-2 rounded-lg bg-white/60 dark:bg-white/5 hover:bg-white/80 dark:hover:bg-white/10 text-gray-900 dark:text-white border border-gray-300 dark:border-white/10 backdrop-blur-sm dark:backdrop-blur-lg transition-all duration-200 flex items-center gap-2 font-medium whitespace-nowrap">
                <Icon :iconNode="broom" class="w-5 h-5 text-gray-900 dark:text-white" />
                <span>Limpar Filtros</span>
              </button>

              <!-- Campo de Busca -->
              <div class="relative flex-1 min-w-[200px]">
                <search-icon
                  class="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-600 dark:text-gray-400" />
                <input type="text" placeholder="Buscar indicador..."
                  class="w-full pl-10 pr-4 py-2 rounded-lg bg-white/60 dark:bg-white/5 border border-gray-300 dark:border-white/10 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 backdrop-blur-sm dark:backdrop-blur-lg transition-all"
                  v-model="searchQuery" />
              </div>

              <!-- Botão CCDTI -->
              <button @click="setActiveTypeFilter('CCDTI')" :class="[
                'px-3 py-1.5 rounded-lg text-sm font-medium transition-all whitespace-nowrap backdrop-blur-sm dark:backdrop-blur-lg flex items-center gap-1',
                activeTypeFilter === 'CCDTI'
                  ? 'bg-indigo-600 text-white shadow-md shadow-indigo-200 dark:shadow-indigo-900/30'
                  : 'bg-white/60 dark:bg-white/5 hover:bg-white/80 dark:hover:bg-white/10 text-gray-900 dark:text-white border border-gray-300 dark:border-white/10 backdrop-blur-sm dark:backdrop-blur-lg'
              ]">
                <Activity class="h-3.5 w-3.5" />
                CCDTI
              </button>

              <!-- Botão Avançadas -->
              <button @click="setActiveTypeFilter('Avançadas')" :class="[
                'px-3 py-1.5 rounded-lg text-sm font-medium transition-all whitespace-nowrap backdrop-blur-sm dark:backdrop-blur-lg flex items-center gap-1',
                activeTypeFilter === 'Avançadas'
                  ? 'bg-indigo-600 text-white shadow-md shadow-indigo-200 dark:shadow-indigo-900/30'
                  : 'bg-white/60 dark:bg-white/5 hover:bg-white/80 dark:hover:bg-white/10 text-gray-900 dark:text-white border border-gray-300 dark:border-white/10 backdrop-blur-sm dark:backdrop-blur-lg'
              ]">
                <Activity class="h-3.5 w-3.5" />
                Avançadas
              </button>

              <!-- Select de Unidades (com transição) -->
              <Transition enter-active-class="transition-all duration-300 ease-out"
                enter-from-class="opacity-0 -translate-x-4 scale-95"
                enter-to-class="opacity-100 translate-x-0 scale-100"
                leave-active-class="transition-all duration-200 ease-in"
                leave-from-class="opacity-100 translate-x-0 scale-100"
                leave-to-class="opacity-0 -translate-x-4 scale-95">
                <select v-if="activeTypeFilter !== 'CCDTI'" id="filterUnidade" v-model="activeUnitFilter" :class="[
                  'px-4 py-2 rounded-lg border font-medium transition-all whitespace-nowrap backdrop-blur-sm dark:backdrop-blur-lg',
                  isUnitFilterActive
                    ? 'bg-blue-600 hover:bg-blue-700 text-white border-blue-600 shadow-lg'
                    : 'bg-white/60 dark:bg-white/5 hover:bg-white/80 dark:hover:bg-white/10 text-gray-900 dark:text-white border-gray-300 dark:border-white/10 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 backdrop-blur-sm dark:backdrop-blur-lg'
                ]">
                  <option value="" class="bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
                    Todas as unidades
                  </option>
                  <option v-for="unit in availableUnits" :key="unit.id" :value="unit.id"
                    class="bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
                    {{ unit.nome || `Unidade ${unit.id}` }}
                  </option>
                </select>
              </Transition>


              <!-- Botão Modo Kiosk -->
              <button @click="toggleKioskMode" :class="[
                'px-4 py-2 rounded-lg border font-medium transition-all flex items-center gap-2 whitespace-nowrap backdrop-blur-sm dark:backdrop-blur-lg',
                isKioskMode
                  ? 'bg-red-600 text-white border-red-600 shadow-lg'
                  : 'bg-white/60 dark:bg-white/5 hover:bg-white/80 dark:hover:bg-white/10 text-gray-900 dark:text-white border-gray-300 dark:border-white/10 backdrop-blur-sm dark:backdrop-blur-lg'
              ]">
                <maximize-2-icon v-if="!isKioskMode" class="h-4 w-4 text-gray-900 dark:text-white" />
                <minimize-2-icon v-else class="h-4 w-4 text-gray-900 dark:text-white" />
                {{ isKioskMode ? '' : '' }}
              </button>
            </div>
          </div>
        </div>

        <!-- Informação sobre a fonte dos dados -->
        <div v-if="!isKioskMode && (currentView === 'overview')" class="flex justify-between items-end mb-4">
          <p class="text-sm text-gray-600 dark:text-gray-400 text-left">
            <span class="font-medium">Fonte dos indicadores:</span> Prontuário Eletrônico da Medilab Sistemas
          </p>

          <div class="flex gap-3 items-center">

            <div class="relative">
              <select v-model="reportMode"
                class="pl-4 pr-10 py-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none font-medium cursor-pointer shadow-sm hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors"
                title="Escolha o conteúdo do PDF">
                <option value="ambos">Completo</option>
                <option value="tabela">Apenas Tabela</option>
                <option value="graficos">Apenas Gráficos</option>
              </select>

              <div
                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3 text-gray-500 dark:text-gray-400">
                <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </div>
            </div>

            <button @click="carregarRelatorio" :disabled="carregandoRelatorio"
              class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all font-medium flex items-center justify-center min-w-[160px] disabled:opacity-70 disabled:cursor-not-allowed shadow-md hover:shadow-lg">
              <span v-if="carregandoRelatorio" class="flex items-center">
                <svg class="animate-spin mr-2 h-5 w-5 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="4">
                  <circle class="opacity-25" cx="12" cy="12" r="10"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.4 0 0 5.4 0 12h4z"></path>
                </svg>
                Carregando...
              </span>
              <span v-else>Gerar Relatório</span>
            </button>

            <transition enter-active-class="transition-all duration-300 ease-out"
              enter-from-class="opacity-0 translate-x-4" enter-to-class="opacity-100 translate-x-0"
              leave-active-class="transition-all duration-200 ease-in" leave-from-class="opacity-100 translate-x-0"
              leave-to-class="opacity-0 translate-x-4">
              <div v-if="dadosRelatorio && dadosRelatorio.indicadores && dadosRelatorio.indicadores.length > 0"
                class="flex gap-2">

                <button @click="gerarPDF" :disabled="isGeneratingPDF || isGeneratingPPT"
                  class="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-all font-medium flex items-center gap-2 shadow-md hover:shadow-lg disabled:opacity-70 disabled:cursor-not-allowed">
                  <span v-if="isGeneratingPDF" class="flex items-center">
                    <svg class="animate-spin mr-2 h-4 w-4 text-white" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="4">
                      <circle class="opacity-25" cx="12" cy="12" r="10"></circle>
                      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.4 0 0 5.4 0 12h4z"></path>
                    </svg>
                    PDF
                  </span>
                  <span v-else class="flex items-center gap-2">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
                      </path>
                    </svg>
                    PDF
                  </span>
                </button>

                <button @click="gerarPPT" :disabled="isGeneratingPDF || isGeneratingPPT"
                  class="px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition-all font-medium flex items-center gap-2 shadow-md hover:shadow-lg disabled:opacity-70 disabled:cursor-not-allowed">
                  <span v-if="isGeneratingPPT" class="flex items-center">
                    <svg class="animate-spin mr-2 h-4 w-4 text-white" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="4">
                      <circle class="opacity-25" cx="12" cy="12" r="10"></circle>
                      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.4 0 0 5.4 0 12h4z"></path>
                    </svg>
                    PPT
                  </span>
                  <span v-else class="flex items-center gap-2">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"></path>
                    </svg>
                    PPT
                  </span>
                </button>

              </div>
            </transition>
          </div>
        </div>

        <div v-if="currentView === 'overview'" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div v-for="indicator in currentPageIndicators" :key="indicator.codigo" :class="[
            'bg-white dark:bg-gray-800 rounded-xl shadow-xl hover:shadow-2xl dark:shadow-md dark:hover:shadow-lg border border-gray-100 dark:border-gray-700 transition-all duration-200 group min-h-[420px]',
            getMeta(getCodigoParaMeta(indicator)) !== null && isMetaAtingida(indicator) === true
              ? 'shadow-[0_0_20px_rgba(34,197,94,0.5)] dark:shadow-[0_0_20px_rgba(34,197,94,0.3)] animate-pulse-slow'
              : getMeta(getCodigoParaMeta(indicator)) !== null && isMetaAtingida(indicator) === false
                ? 'shadow-[0_0_20px_rgba(239,68,68,0.5)] dark:shadow-[0_0_20px_rgba(239,68,68,0.3)] animate-pulse-slow'
                : ''
          ]">
            <div class="p-5">
              <div class="flex justify-between items-start mb-4">
                <div class="flex-1 pr-4">
                  <div class="flex flex-wrap items-center gap-2">
                    <!-- Título com edição -->
                    <div class="flex items-center gap-2">
                      <h3 v-if="!editingTitle[indicator.codigoOriginal]"
                        :class="['font-semibold', isKioskMode ? 'text-2xl' : 'text-lg', 'uppercase', 'text-gray-900 dark:text-white']">
                        <span :class="[isKioskMode ? 'max-w-[200px]' : 'max-w-[120px] sm:max-w-[150px]']">
                          {{ getIndicatorTitle(indicator.codigo, indicator.nome_fantasia) }}
                        </span>
                      </h3>
                      <div v-else class="flex items-center gap-2 flex-1">
                        <input type="text" v-model="editTitleValue[indicator.codigoOriginal]"
                          @keyup.enter="saveNomeFantasia(indicator.codigoOriginal, 'titulo')"
                          @keyup.esc="cancelEditing(indicator.codigoOriginal, 'titulo')"
                          class="flex-1 px-2 py-1 text-sm font-semibold uppercase bg-white dark:bg-gray-700 border border-blue-500 rounded text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                          :class="[isKioskMode ? 'text-2xl' : 'text-lg']" />
                        <button @click="saveNomeFantasia(indicator.codigoOriginal, 'titulo')"
                          class="p-1 text-green-600 dark:text-green-400 hover:bg-green-100 dark:hover:bg-green-900/30 rounded transition-colors"
                          title="Salvar">
                          <CheckIcon class="w-4 h-4" />
                        </button>
                        <button @click="cancelEditing(indicator.codigoOriginal, 'titulo')"
                          class="p-1 text-red-600 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-900/30 rounded transition-colors"
                          title="Cancelar">
                          <XIcon class="w-4 h-4" />
                        </button>
                      </div>
                      <button v-if="!editingTitle[indicator.codigoOriginal] && !isKioskMode"
                        @click="startEditing(indicator.codigoOriginal, 'titulo')"
                        class="p-1 text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition-colors"
                        title="Editar título">
                        <PencilIcon class="w-4 h-4" />
                      </button>
                    </div>

                    <span v-if="indicator.indicadores[0]?.unidade_nome && activeTypeFilter !== 'CCDTI'"
                      class="px-2 py-0.5 rounded text-xs font-bold bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200 uppercase tracking-wide whitespace-nowrap">
                      {{ indicator.indicadores[0]?.unidade_nome }}
                    </span>
                  </div>

                  <!-- Descrição com edição -->
                  <div v-if="indicator.indicadores[0]?.unidade_nome !== 'Todas as unidades'"
                    class="flex items-center gap-2 mt-1 min-h-[20px]">
                    <p v-if="!editingDescription[indicator.codigoOriginal]"
                      class="text-sm text-gray-500 dark:text-gray-400 flex-1">
                      {{ getIndicatorDescription(indicator.codigo, indicator.nome_fantasia) }}
                    </p>
                    <div v-else class="flex items-center gap-2 flex-1">
                      <input type="text" v-model="editDescriptionValue[indicator.codigoOriginal]"
                        @keyup.enter="saveNomeFantasia(indicator.codigoOriginal, 'descricao')"
                        @keyup.esc="cancelEditing(indicator.codigoOriginal, 'descricao')"
                        class="flex-1 px-2 py-1 text-sm bg-white dark:bg-gray-700 border border-blue-500 rounded text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500" />
                      <button @click="saveNomeFantasia(indicator.codigoOriginal, 'descricao')"
                        class="p-1 text-green-600 dark:text-green-400 hover:bg-green-100 dark:hover:bg-green-900/30 rounded transition-colors"
                        title="Salvar">
                        <CheckIcon class="w-4 h-4" />
                      </button>
                      <button @click="cancelEditing(indicator.codigoOriginal, 'descricao')"
                        class="p-1 text-red-600 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-900/30 rounded transition-colors"
                        title="Cancelar">
                        <XIcon class="w-4 h-4" />
                      </button>
                    </div>
                    <button v-if="!editingDescription[indicator.codigoOriginal] && !isKioskMode"
                      @click="startEditing(indicator.codigoOriginal, 'descricao')"
                      class="p-1 text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition-colors shrink-0"
                      title="Editar descrição">
                      <PencilIcon class="w-4 h-4" />
                    </button>
                  </div>
                </div>
                <div v-if="!isKioskMode" class="flex bg-gray-100 dark:bg-gray-700/50 rounded-lg p-1 gap-1 shrink-0">
                  <button @click="setIndicatorMode(indicator.codigo, 'line')" :class="[
                    'p-1.5 rounded-md transition-all',
                    getIndicatorMode(indicator.codigo) === 'line'
                      ? 'bg-white dark:bg-gray-600 text-blue-600 dark:text-blue-400 shadow-sm'
                      : 'text-gray-400 hover:text-gray-600 dark:hover:text-gray-300'
                  ]" title="Gráfico de Linha">
                    <LineChart class="h-4 w-4" />
                  </button>

                  <button @click="setIndicatorMode(indicator.codigo, 'bar')" :class="[
                    'p-1.5 rounded-md transition-all',
                    getIndicatorMode(indicator.codigo) === 'bar'
                      ? 'bg-white dark:bg-gray-600 text-blue-600 dark:text-blue-400 shadow-sm'
                      : 'text-gray-400 hover:text-gray-600 dark:hover:text-gray-300'
                  ]" title="Gráfico de Barras">
                    <BarChart3 class="h-4 w-4" />
                  </button>

                  <button @click="setIndicatorMode(indicator.codigo, 'doughnut')" :class="[
                    'p-1.5 rounded-md transition-all',
                    getIndicatorMode(indicator.codigo) === 'doughnut'
                      ? 'bg-white dark:bg-gray-600 text-blue-600 dark:text-blue-400 shadow-sm'
                      : 'text-gray-400 hover:text-gray-600 dark:hover:text-gray-300'
                  ]" title="Gráfico de Rosca">
                    <PieChart class="h-4 w-4" />
                  </button>
                </div>
              </div>

              <!-- Valor Atual do Indicador (para gráficos de linha e barra) -->
              <div class="mb-4">
                <div
                  class="flex items-center justify-between bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-gray-700/50 dark:to-gray-800/50 rounded-lg p-4 border border-blue-100 dark:border-gray-600">
                  <div class="flex-1">
                    <p class="text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Valor Atual (Último Mês)</p>
                    <p class="text-3xl font-bold" :class="{
                      'text-green-600 dark:text-green-400': getMeta(getCodigoParaMeta(indicator)) !== null && isMetaAtingida(indicator) === true,
                      'text-red-600 dark:text-red-400': getMeta(getCodigoParaMeta(indicator)) !== null && isMetaAtingida(indicator) === false,
                      'text-blue-600 dark:text-blue-400': getMeta(getCodigoParaMeta(indicator)) === null || isMetaAtingida(indicator) === null
                    }">
                      {{ getCurrentValue(indicator) !== null ? getCurrentValue(indicator).toFixed(2) + '%' : 'N/A' }}
                    </p>
                  </div>
                  <div v-if="getMeta(getCodigoParaMeta(indicator)) !== null" class="text-right">
                    <p class="text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Meta</p>
                    <p class="text-xl font-semibold text-gray-700 dark:text-gray-300">
                      {{ formatMeta(getMeta(getCodigoParaMeta(indicator)), getCodigoParaMeta(indicator)) }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Tendência do Indicador -->
              <div class="mb-6">
                <div class="flex items-center gap-3">
                  <span v-if="indicator.analise_periodo.tendencia === 'subiu'"
                    class="flex items-center justify-center h-8 w-8 rounded-full bg-green-100 dark:bg-green-900/30">
                    <ArrowUpIcon class="h-5 w-5 text-green-600 dark:text-green-400" />
                  </span>
                  <span v-if="indicator.analise_periodo.tendencia === 'desceu'"
                    class="flex items-center justify-center h-8 w-8 rounded-full bg-red-100 dark:bg-red-900/30">
                    <ArrowDownIcon class="h-5 w-5 text-red-600 dark:text-red-400" />
                  </span>
                  <span v-if="indicator.analise_periodo.tendencia === 'neutra'"
                    class="flex items-center justify-center h-8 w-8 rounded-full bg-gray-100 dark:bg-gray-800">
                    <span class="h-2 w-2 rounded-full bg-gray-400"></span>
                  </span>
                  <div>
                    <p class="text-sm font-semibold text-gray-900 dark:text-white">
                      <span :class="{
                        'text-green-600 dark:text-green-400 text-xl': indicator.analise_periodo.tendencia === 'subiu',
                        'text-red-600 dark:text-red-400 text-xl': indicator.analise_periodo.tendencia === 'desceu',
                        'text-gray-500 dark:text-gray-400 text-xl': indicator.analise_periodo.tendencia === 'neutra',
                      }">
                        {{ indicator.analise_periodo.diferencaPercentual.toFixed(2) }}%
                      </span>
                    </p>
                    <p class="text-xs text-gray-500 dark:text-gray-400">
                      em relação ao mês anterior ({{ indicator.analise_periodo.mesInicial }})
                    </p>
                  </div>
                </div>
              </div>

              <!-- Gráfico do Indicador -->
              <div class="h-64 relative mt-6">
                <template v-if="getIndicatorMode(indicator.codigo) === 'doughnut'">
                  <div class="flex flex-col items-center justify-center h-full w-full">

                    <div class="relative h-40 w-40">
                      <Doughnut :ref="(el) => saveChartRef(el, indicator.codigo)"
                        :data="getDoughnutChartData(indicator)" :options="doughnutChartOptions" />

                      <div class="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
                        <template v-if="getMeta(getCodigoParaMeta(indicator))">
                          <span class="text-2xl font-bold" :class="getDoughnutTextColorClass(indicator)">
                            {{ ((getDoughnutValue(indicator) / getMeta(getCodigoParaMeta(indicator)).valor) *
                              100).toFixed(0) }}%
                          </span>
                          <span class="text-[10px] text-gray-500 dark:text-gray-400 font-medium uppercase mt-0.5">
                            da Meta
                          </span>
                        </template>
                        <template v-else>
                          <span class="text-xl font-bold text-blue-600 dark:text-blue-400">
                            {{ getDoughnutValue(indicator)?.toFixed(1) }}%
                          </span>
                          <span class="text-[10px] text-gray-500 dark:text-gray-400 font-medium uppercase mt-0.5">
                            Realizado
                          </span>
                        </template>
                      </div>
                    </div>

                    <div class="text-center mt-2 mb-3">
                      <p class="text-sm font-medium text-gray-700 dark:text-gray-300">
                        <span v-if="getMeta(getCodigoParaMeta(indicator))">
                          {{ getDoughnutValue(indicator)?.toFixed(2) }}%
                          <span class="text-gray-400 mx-1">/</span>
                          {{ getMeta(getCodigoParaMeta(indicator)).valor }}%
                        </span>
                        <span v-else>
                          {{ getDoughnutValue(indicator)?.toFixed(2) }}%
                        </span>
                      </p>
                      <p class="text-[10px] text-gray-400 uppercase">
                        {{ getMeta(getCodigoParaMeta(indicator)) ? 'Valor do Mês vs. Meta' : 'Valor do Mês' }}
                      </p>
                    </div>

                    <div class="flex items-center justify-center gap-4 mx-auto"> <button
                        @click.stop="navigateDoughnut(indicator, -1)"
                        :disabled="!getSelectedMonthData(indicator) || getAllMonthsData(indicator).indexOf(getSelectedMonthData(indicator)) === 0"
                        class="p-1 hover:bg-gray-100 dark:hover:bg-white/10 rounded-full transition-colors disabled:opacity-30 disabled:cursor-not-allowed text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7">
                          </path>
                        </svg>
                      </button>

                      <span
                        class="text-xs font-bold text-gray-600 dark:text-gray-400 uppercase min-w-[80px] text-center select-none tracking-wider">
                        {{ getSelectedMonthData(indicator)?.titulo || 'S/ DADOS' }}
                      </span>

                      <button @click.stop="navigateDoughnut(indicator, 1)"
                        :disabled="!getSelectedMonthData(indicator) || getAllMonthsData(indicator).indexOf(getSelectedMonthData(indicator)) === getAllMonthsData(indicator).length - 1"
                        class="p-1 hover:bg-gray-100 dark:hover:bg-white/10 rounded-full transition-colors disabled:opacity-30 disabled:cursor-not-allowed text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                        </svg>
                      </button>
                    </div>

                  </div>
                </template>

                <template v-else-if="getIndicatorMode(indicator.codigo) === 'bar'">
                  <Bar :ref="(el) => saveChartRef(el, indicator.codigo)" :data="getBarChartData(indicator)"
                    :options="barChartOptions" class="h-40" />
                </template>

                <template v-else>
                  <Line :ref="(el) => saveChartRef(el, indicator.codigo)" :data="getLineChartData(indicator)"
                    :options="isKioskMode ? kioskLineChartOptions : lineChartOptions" class="h-40" />
                </template>
              </div>
              <!-- Rodapé do Card com Datas -->
              <div
                class="mt-4 pt-4 border-t border-gray-100 dark:border-gray-700 flex justify-between text-[10px] text-gray-400 dark:text-gray-500">
                <span>Data da consulta: {{ lastFetchTime }}</span>
                <span>Últimos dados: {{ getLastDataDate(indicator) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </BaseTemplate>

  <!-- Modo Kiosk -->
  <div v-else
    class="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 text-white transition-all duration-300">
    <div class="bg-black/30 backdrop-blur-sm border-b border-white/10 p-6">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-4 min-w-[180px]">
          <img src="@/assets/logo_ccdti.png" alt="Logo CCDTI" class="h-12 w-auto" />
        </div>
        <div class="flex-1 flex flex-col items-center">
          <h1
            class="text-4xl font-bold bg-gradient-to-r from-blue-400 to-cyan-300 bg-clip-text text-transparent text-center w-full">
            {{ kioskTitle }}
          </h1>
          <div v-if="kioskDateRange" class="flex gap-4 mt-4">
            <div class="bg-blue-500/20 border border-blue-400/30 rounded-lg px-4 py-1">
              <span class="text-blue-300 text-lg font-semibold">{{ kioskDateRange }}</span>
            </div>
          </div>
        </div>
        <div class="text-right min-w-[120px]">
          <div class="text-2xl font-mono">{{ currentTime }}</div>
          <div class="text-sm text-gray-300">{{ currentDate }}</div>
        </div>
      </div>
    </div>

    <div class="p-8">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div v-for="indicator in currentPageIndicators" :key="indicator.codigo" :class="[
          'bg-black/30 backdrop-blur-sm border border-white/10 rounded-2xl p-5 transition-all duration-300 shadow-lg shadow-black/50',
          'min-h-[360px]',
          getMeta(getCodigoParaMeta(indicator)) !== null && isMetaAtingida(indicator) === true
            ? 'shadow-[0_0_20px_rgba(34,197,94,0.5)] animate-pulse-slow'
            : getMeta(getCodigoParaMeta(indicator)) !== null && isMetaAtingida(indicator) === false
              ? 'shadow-[0_0_20px_rgba(239,68,68,0.5)] animate-pulse-slow'
              : ''
        ]">
          <div class="flex flex-wrap items-center gap-3 mb-1">
            <h3 class="font-semibold text-white transition-colors text-xl uppercase">
              <span class="max-w-[200px]">
                {{ getIndicatorTitle(indicator.codigo) }}
              </span>
            </h3>
            <span v-if="indicator.indicadores[0]?.unidade_nome && activeTypeFilter !== 'CCDTI'"
              class="px-3 py-1 rounded-full text-sm font-bold bg-blue-500/30 text-blue-200 border border-blue-500/50 uppercase tracking-wider">
              {{ indicator.indicadores[0]?.unidade_nome }}
            </span>
          </div>
          <p v-if="indicator.indicadores[0]?.unidade_nome !== 'Todas as unidades'"
            class="text-md text-gray-400 mb-3 min-h-[28px]">
            {{ getIndicatorDescription(indicator.codigo) }}
          </p>

          <!-- Valor Atual do Indicador (para gráficos de linha e barra) - Modo Kiosk -->
          <div class="mt-3 mb-2">
            <div
              class="flex items-center justify-between bg-white/10 backdrop-blur-sm rounded-lg p-3 border border-white/20">
              <div class="flex-1">
                <p class="text-xs font-medium text-gray-300 mb-1">Valor Atual (Último Mês)</p>
                <p class="text-2xl font-bold" :class="{
                  'text-green-400': getMeta(getCodigoParaMeta(indicator)) !== null && isMetaAtingida(indicator) === true,
                  'text-red-400': getMeta(getCodigoParaMeta(indicator)) !== null && isMetaAtingida(indicator) === false,
                  'text-blue-300': getMeta(getCodigoParaMeta(indicator)) === null || isMetaAtingida(indicator) === null
                }">
                  {{ getCurrentValue(indicator) !== null ? getCurrentValue(indicator).toFixed(2) + '%' : 'N/A' }}
                </p>
              </div>
              <div v-if="getMeta(getCodigoParaMeta(indicator)) !== null" class="text-right">
                <p class="text-xs font-medium text-gray-300 mb-1">Meta</p>
                <p class="text-xl font-semibold text-white">
                  {{ formatMeta(getMeta(getCodigoParaMeta(indicator)), getCodigoParaMeta(indicator)) }}
                </p>
              </div>
            </div>
          </div>
          <div v-if="indicator.analise_periodo" class="mb-6">
            <div class="flex items-center gap-3">
              <span v-if="indicator.analise_periodo.tendencia === 'subiu'"
                class="flex items-center justify-center h-8 w-8 rounded-full bg-green-900/30">
                <ArrowUpIcon class="h-5 w-5 text-green-400" />
              </span>
              <span v-if="indicator.analise_periodo.tendencia === 'desceu'"
                class="flex items-center justify-center h-8 w-8 rounded-full bg-red-900/30">
                <ArrowDownIcon class="h-5 w-5 text-red-400" />
              </span>
              <div>
                <p class="text-sm font-semibold text-white">
                  <span :class="{
                    'text-green-400 text-xl': indicator.analise_periodo.tendencia === 'subiu',
                    'text-red-400 text-xl': indicator.analise_periodo.tendencia === 'desceu',
                    'text-gray-400 text-xl': indicator.analise_periodo.tendencia === 'neutra',
                  }">
                    {{ indicator.analise_periodo.diferencaPercentual.toFixed(2) }}%
                  </span>
                </p>
                <p class="text-xs text-gray-400">
                  em relação ao mês anterior ({{ indicator.analise_periodo.mesInicial }})
                </p>
              </div>
            </div>
          </div>
          <div v-else-if="getIndicatorMode(indicator.codigo) === 'doughnut'" class="mb-6"></div>
          <div class="relative mt-6 flex justify-center">
            <template v-if="getIndicatorMode(indicator.codigo) === 'doughnut'">
              <div class="flex flex-col items-center justify-center">
                <div class="relative h-32 w-32">
                  <Doughnut :data="getDoughnutChartData(indicator)" :options="doughnutChartOptions" />
                  <div class="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
                    <template v-if="getMeta(getCodigoParaMeta(indicator))">
                      <span class="text-3xl font-bold" :class="getDoughnutTextColorClass(indicator)">
                        {{ ((getCurrentValue(indicator) / getMeta(getCodigoParaMeta(indicator)).valor) * 100).toFixed(0)
                        }}%
                      </span>
                      <span class="text-[10px] text-gray-400 font-medium uppercase mt-1">
                        da Meta
                      </span>
                    </template>
                    <template v-else>
                      <span class="text-2xl font-bold text-blue-300">
                        {{ getCurrentValue(indicator)?.toFixed(1) }}%
                      </span>
                      <span class="text-[10px] text-gray-400 font-medium uppercase mt-1">
                        Realizado
                      </span>
                    </template>
                  </div>
                </div>

              </div>
            </template>
            <template v-else-if="getIndicatorMode(indicator.codigo) === 'bar'">
              <Bar :data="getBarChartData(indicator)" :options="kioskBarChartOptions" class="h-40 w-full" />
            </template>
            <template v-else>
              <Line :data="getLineChartData(indicator)" :options="kioskLineChartOptions" class="h-40 w-full" />
            </template>
          </div>
          <!-- Rodapé do Card com Datas (Kiosk) -->
          <div class="mt-4 pt-4 border-t border-white/20 flex justify-between text-[10px] text-gray-400">
            <span>Data da consulta: {{ lastFetchTime }}</span>
            <span>Últimos dados: {{ getLastDataDate(indicator) }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="fixed top-4 right-4 flex gap-2">
      <button @click="toggleKioskMode"
        class="px-4 py-2 rounded-lg border font-medium transition-all flex items-center gap-2 bg-red-600 text-white border-red-600 dark:border-red-500 hover:bg-red-700">
        <minimize-2-icon class="h-4 w-4" />
      </button>
    </div>
  </div>

  <!-- Modal de Filtro de Data -->
  <ModalTemplate v-if="showDateFilterModal" @close="closeDateFilterModal">
    <template #header>Filtrar Período</template>
    <template #body>
      <div class="space-y-4">
        <!-- Selector de Granularidade -->
        <div>
          <label for="filterGranularity" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Visualização
          </label>
          <select id="filterGranularity" v-model="localDateFilter.granularity"
            class="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white">
            <option v-for="option in granularityOptions" :key="option.value" :value="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>

        <!-- Opções Mensais -->
        <template v-if="localDateFilter.granularity === 'mensal'">
          <div class="flex flex-col sm:flex-row gap-4">
            <div class="flex-1">
              <label for="filterStartYear" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Ano Inicial
              </label>
              <select id="filterStartYear" v-model="localDateFilter.startYear"
                class="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                <option value="">Selecione</option>
                <option v-for="year in startYearOptions" :key="`start-yr-${year}`" :value="year">
                  {{ year }}
                </option>
              </select>
            </div>
            <div class="flex-1">
              <label for="filterStartMonth" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Mês Inicial
              </label>
              <select id="filterStartMonth" v-model="localDateFilter.startMonth"
                class="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                <option value="">Selecione</option>
                <option v-for="month in monthOptions" :key="`start-mo-${month.value}`" :value="month.value">
                  {{ month.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="flex flex-col sm:flex-row gap-4">
            <div class="flex-1">
              <label for="filterEndYear" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Ano Final
              </label>
              <select id="filterEndYear" v-model="localDateFilter.endYear" :disabled="!localDateFilter.startYear"
                class="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white disabled:opacity-50 disabled:cursor-not-allowed">
                <option value="">Selecione</option>
                <option v-for="year in endYearOptions" :key="`end-yr-${year}`" :value="year">
                  {{ year }}
                </option>
              </select>
            </div>
            <div class="flex-1">
              <label for="filterEndMonth" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Mês Final
              </label>
              <select id="filterEndMonth" v-model="localDateFilter.endMonth" :disabled="!localDateFilter.endYear"
                class="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white disabled:opacity-50 disabled:cursor-not-allowed">
                <option value="">Selecione</option>
                <option v-for="month in endMonthOptions" :key="`end-mo-${month.value}`" :value="month.value">
                  {{ month.name }}
                </option>
              </select>
            </div>
          </div>
        </template>

        <!-- Opções Semanal/Diário -->
        <template v-else>
          <div class="flex flex-col sm:flex-row gap-4">
            <div class="flex-1">
              <label for="filterStartDate" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Data Inicial
              </label>
              <input type="date" id="filterStartDate" v-model="localDateFilter.startDate"
                class="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white" />
            </div>
            <div class="flex-1">
              <label for="filterEndDate" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Data Final
              </label>
              <input type="date" id="filterEndDate" v-model="localDateFilter.endDate"
                class="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white" />
            </div>
          </div>
        </template>
      </div>
      <div class="flex justify-end mt-6 space-x-4">
        <button @click="closeDateFilterModal"
          class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300 dark:bg-gray-600 dark:text-gray-200 dark:hover:bg-gray-500">
          Cancelar
        </button>
        <button @click="applyDateFilter"
          class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700">
          Aplicar Filtros
        </button>
      </div>
    </template>
  </ModalTemplate>
</template>

<script setup>
import BaseTemplate from '../templates/BaseTemplate.vue';
import ModalTemplate from '@/views/templates/ModalTemplate.vue';
import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue';
import apiClient from '@/services/authService';
import jsPDF from 'jspdf';
import PptxGenJS from 'pptxgenjs';
import { useUserStore } from '@/stores/userStore';
import { useIndicatorsStore } from '@/stores/indicators/indicatorsStore';
import logoSaude from '@/assets/Logo_PCRJ-Saude.png';

const indicatorsStore = useIndicatorsStore();

const indicatorsRawData = ref([]);
const isLoading = ref(true);
const error = ref(null);
const carregandoRelatorio = ref(false)
const dadosRelatorio = ref({ eventos: [] })
const isGeneratingPDF = ref(false);
const isGeneratingPPT = ref(false);
const doughnutSelections = ref({});
const lastFetchTime = ref('');

// Helper para obter data do último dado
const getLastDataDate = (grupo) => {
  if (!grupo || !grupo.indicadores || !grupo.indicadores[0]?.dados) return 'N/A';
  const dados = grupo.indicadores[0].dados.filter(d => d.titulo !== 'SET');
  if (dados.length === 0) return 'N/A';

  // Tenta interpretar o formato
  const ultimo = dados[dados.length - 1];
  return ultimo.titulo || 'N/A'; // Assume que o titulo é a data (YYYY/MM ou YYYY-MM-DD...)
};

// Estados para edição de nomes fantasia
const editingTitle = ref({});
const editingDescription = ref({});
const editTitleValue = ref({});
const editDescriptionValue = ref({});

async function fetchIndicators() {
  isLoading.value = true;
  error.value = null;

  try {
    // Construir parâmetros de query baseados nos filtros ativos
    const params = {};

    // Filtro de tipo (CCDTI ou Avançadas)
    if (activeTypeFilter.value) {
      params.tipo = activeTypeFilter.value;
    }

    // Filtro de unidade (apenas para tipo Avançadas)
    if (activeTypeFilter.value === 'Avançadas' && activeUnitFilter.value) {
      params.unidade_id = activeUnitFilter.value;
    }

    // Filtros de Data
    const dateFilter = indicatorsStore.filters.date;
    if (dateFilter.granularity) {
      params.periodo = dateFilter.granularity; // 'mensal', 'semanal', 'diario'
    }

    if (dateFilter.granularity === 'mensal') {
      if (dateFilter.startYear && dateFilter.startMonth) {
        params.start_date = `${dateFilter.startYear}-${String(dateFilter.startMonth).padStart(2, '0')}-01`;
      }
      if (dateFilter.endYear && dateFilter.endMonth) {
        const lastDay = new Date(dateFilter.endYear, dateFilter.endMonth, 0).getDate();
        params.end_date = `${dateFilter.endYear}-${String(dateFilter.endMonth).padStart(2, '0')}-${lastDay}`;
      }
    } else {
      // Semanal ou Diário
      if (dateFilter.startDate) {
        params.start_date = dateFilter.startDate;
      }
      if (dateFilter.endDate) {
        params.end_date = dateFilter.endDate;
      }
    }

    const indicatorsResponse = await apiClient.get('/api/v1/indicadores/', { params });
    const responseData = indicatorsResponse.data;

    if (responseData && responseData.indicadores) {
      const rawIndicatorsData = responseData.indicadores;

      indicatorsRawData.value = rawIndicatorsData;

    } else {
      console.warn("Resposta da API de indicadores não contém a chave 'indicadores' ou está vazia.", responseData);
      throw new Error("Formato de dados inesperado recebido.");
    }

  } catch (err) {
    console.error("Erro ao buscar indicadores:", err);
    error.value = "Não foi possível carregar os indicadores. Por favor, tente novamente.";

    if (err.response) {
      console.error("Detalhes do erro HTTP:", err.response.data);
    }
  } finally {
    isLoading.value = false;
    lastFetchTime.value = new Date().toLocaleString('pt-BR');
  }
}

const indicators = computed(() => {
  const rawData = indicatorsRawData.value;

  if (!rawData || rawData.length === 0) {
    return [];
  }

  // Verificar se "Todas as unidades" está selecionado (quando activeUnitFilter está vazio para Avançadas)
  const isTodasUnidades = activeTypeFilter.value === 'Avançadas' && !activeUnitFilter.value;

  // Primeiro, processar todos os indicadores
  const todosIndicadores = rawData.flatMap(grupo => {
    if (!grupo.indicadores || grupo.indicadores.length === 0) {
      return [];
    }

    return grupo.indicadores.map(indicadorIndividual => {
      const grupoUnico = {
        ...grupo,
        codigoOriginal: grupo.codigo,
        codigo: `${grupo.codigo}_${indicadorIndividual.id}`,
        indicadores: [indicadorIndividual],
        nome_fantasia: grupo.nome_fantasia || null
      };

      return calculatePeriodAnalysis(grupoUnico);
    });
  });

  // Se "Todas as unidades" está selecionado, agrupar por código
  if (isTodasUnidades) {
    const indicadoresAgrupados = new Map();

    todosIndicadores.forEach(indicator => {
      const codigoBase = indicator.codigoOriginal;

      if (!indicadoresAgrupados.has(codigoBase)) {
        // Criar novo indicador agrupado
        const primeiroIndicador = indicator.indicadores[0];
        const dadosAgrupados = new Map();

        // Agrupar dados por mês (titulo)
        (primeiroIndicador.dados || []).forEach(dado => {
          if (dado.titulo === 'SET') return;

          const mes = dado.titulo;
          if (!dadosAgrupados.has(mes)) {
            dadosAgrupados.set(mes, {
              titulo: mes,
              numerador: 0,
              denominador: 0,
              valor: 0
            });
          }

          const agregado = dadosAgrupados.get(mes);
          agregado.numerador += parseFloat(dado.numerador || 0);
          agregado.denominador += parseFloat(dado.denominador || 0);
        });

        // Calcular valores percentuais para cada mês
        const dadosFinais = Array.from(dadosAgrupados.values()).map(d => ({
          ...d,
          valor: d.denominador > 0 ? (d.numerador / d.denominador) * 100 : 0
        })).sort((a, b) => {
          // Ordenar por data (assumindo formato YYYY/MM)
          return a.titulo.localeCompare(b.titulo);
        });

        const indicadorAgrupado = {
          ...indicator,
          codigo: codigoBase + '_agrupado',
          indicadores: [{
            ...primeiroIndicador,
            unidade_nome: 'Todas as unidades',
            unidade_id: null,
            dados: dadosFinais
          }]
        };

        indicadoresAgrupados.set(codigoBase, calculatePeriodAnalysis(indicadorAgrupado));
      } else {
        // Agregar dados ao indicador existente
        const existente = indicadoresAgrupados.get(codigoBase);
        const dadosExistentes = new Map();

        // Mapear dados existentes
        (existente.indicadores[0].dados || []).forEach(d => {
          if (d.titulo !== 'SET') {
            dadosExistentes.set(d.titulo, {
              titulo: d.titulo,
              numerador: parseFloat(d.numerador || 0),
              denominador: parseFloat(d.denominador || 0),
              valor: parseFloat(d.valor || 0)
            });
          }
        });

        // Adicionar dados do novo indicador
        (indicator.indicadores[0].dados || []).forEach(d => {
          if (d.titulo === 'SET') return;

          const mes = d.titulo;
          if (!dadosExistentes.has(mes)) {
            dadosExistentes.set(mes, {
              titulo: mes,
              numerador: 0,
              denominador: 0,
              valor: 0
            });
          }

          const agregado = dadosExistentes.get(mes);
          agregado.numerador += parseFloat(d.numerador || 0);
          agregado.denominador += parseFloat(d.denominador || 0);
        });

        // Recalcular valores percentuais
        const dadosFinais = Array.from(dadosExistentes.values()).map(d => ({
          ...d,
          valor: d.denominador > 0 ? (d.numerador / d.denominador) * 100 : 0
        })).sort((a, b) => a.titulo.localeCompare(b.titulo));

        const indicadorAgrupado = {
          ...existente,
          indicadores: [{
            ...existente.indicadores[0],
            dados: dadosFinais
          }]
        };

        indicadoresAgrupados.set(codigoBase, calculatePeriodAnalysis(indicadorAgrupado));
      }
    });

    return Array.from(indicadoresAgrupados.values());
  }

  // Caso contrário, agrupar por chave única (código + unidade) e manter apenas o mais recente
  const indicadoresMap = new Map();

  todosIndicadores.forEach(indicator => {
    const unidadeId = indicator.indicadores[0]?.unidade_id || null;
    const unidadeNome = indicator.indicadores[0]?.unidade_nome || null;

    // Criar chave única: código + unidade_id (ou unidade_nome se não tiver id)
    const chaveUnica = `${indicator.codigoOriginal}_${unidadeId || unidadeNome || 'default'}`;

    // Contar quantos dados (meses) tem este indicador
    const dadosAtuais = indicator.indicadores[0]?.dados || [];
    const quantidadeDados = dadosAtuais.filter(d => d.titulo !== 'SET').length;

    // Obter timestamp ou ID para comparação
    const timestampAtual = indicator.indicadores[0]?.timestamp || null;
    const idAtual = indicator.indicadores[0]?.id || null;

    // Se já existe um indicador com a mesma chave, manter o mais recente
    if (indicadoresMap.has(chaveUnica)) {
      const existente = indicadoresMap.get(chaveUnica);
      const dadosExistentes = existente.indicadores[0]?.dados || [];
      const quantidadeExistentes = dadosExistentes.filter(d => d.titulo !== 'SET').length;

      // Comparar primeiro por quantidade de dados
      if (quantidadeDados > quantidadeExistentes) {
        indicadoresMap.set(chaveUnica, indicator);
      } else if (quantidadeDados === quantidadeExistentes) {
        // Se a quantidade for igual, usar timestamp ou ID para determinar o mais recente
        const timestampExistente = existente.indicadores[0]?.timestamp || null;
        const idExistente = existente.indicadores[0]?.id || null;

        // Comparar por timestamp se disponível
        if (timestampAtual && timestampExistente) {
          const dataAtual = new Date(timestampAtual);
          const dataExistente = new Date(timestampExistente);
          if (dataAtual > dataExistente) {
            indicadoresMap.set(chaveUnica, indicator);
          }
        } else if (idAtual && idExistente) {
          // Se não tiver timestamp, usar ID (maior ID = mais recente)
          if (idAtual > idExistente) {
            indicadoresMap.set(chaveUnica, indicator);
          }
        }
      }
    } else {
      indicadoresMap.set(chaveUnica, indicator);
    }
  });

  // Retornar apenas os indicadores únicos (sem duplicatas)
  return Array.from(indicadoresMap.values());
});

const kioskDateRange = computed(() => {
  const { startYear, startMonth, endYear, endMonth } = activeDateFilter.value;

  const fmt = (y, m) => y && m ? `${y}/${String(m).padStart(2, '0')}` : null; // "YYYY/MM"

  const startF = fmt(startYear, startMonth);
  const endF = fmt(endYear, endMonth);

  if (startF || endF) {
    // Se forem iguais, mostra só um. Se forem diferentes, mostra "Inicio - Fim"
    return startF === endF ? startF : [startF, endF].filter(Boolean).join(' - ');
  }

  const allDates = filteredIndicators.value
    .flatMap(i => i.analise_periodo ? [i.analise_periodo.mesInicial, i.analise_periodo.mesFinal] : [])
    .filter(Boolean)
    .sort();

  if (!allDates.length) return '';

  const min = allDates[0];
  const max = allDates[allDates.length - 1];

  return min === max ? min : `${min} - ${max}`;
});

const availableUnits = ref([]);

async function fetchAvailableUnits() {
  try {
    const params = {};
    if (activeTypeFilter.value === 'Avançadas') {
      params.tipo = 'Avançadas';
    }

    const response = await apiClient.get('/api/v1/indicadores/unidades-disponiveis/', { params });
    if (response.data && response.data.unidades) {
      availableUnits.value = response.data.unidades;
    } else {
      availableUnits.value = [];
    }
  } catch (err) {
    console.error("Erro ao buscar unidades disponíveis:", err);
    availableUnits.value = [];
  }
}

// Helper function to expand monthly data to daily/weekly granularity for visualization
function expandDataToGranularity(dadosFiltrados) {
  const { granularity, startDate, endDate } = activeDateFilter.value;

  // If monthly or no granularity, return as-is
  if (granularity === 'mensal' || !granularity || !startDate || !endDate) {
    return dadosFiltrados;
  }

  // For daily/weekly, expand monthly data points to individual days
  const expandedData = [];
  const start = new Date(startDate + 'T00:00:00');
  const end = new Date(endDate + 'T23:59:59');

  dadosFiltrados.forEach(item => {
    const titulo = item.titulo;
    let itemDate = null;

    // Parse the date from titulo
    if (titulo.includes('/')) {
      const parts = titulo.split('/');
      if (parts.length === 2) {
        // YYYY/MM format - create date for 1st of month
        itemDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, 1);
      }
    } else if (titulo.includes('-')) {
      // YYYY-MM-DD format
      itemDate = new Date(titulo + 'T00:00:00');
    }

    if (!itemDate || isNaN(itemDate.getTime())) {
      // If can't parse, keep original
      expandedData.push(item);
      return;
    }

    // For monthly data, expand to all days in that month within the filter range
    if (titulo.includes('/') && titulo.split('/').length === 2) {
      const year = itemDate.getFullYear();
      const month = itemDate.getMonth();
      const daysInMonth = new Date(year, month + 1, 0).getDate();

      for (let day = 1; day <= daysInMonth; day++) {
        const dayDate = new Date(year, month, day, 12, 0, 0);

        // Only include if within filter range
        if (dayDate >= start && dayDate <= end) {
          const dayLabel = granularity === 'diario'
            ? `${String(day).padStart(2, '0')}/${String(month + 1).padStart(2, '0')}/${year}`
            : titulo; // For weekly, keep monthly for now

          expandedData.push({
            ...item,
            titulo: dayLabel,
            originalTitulo: titulo
          });
        }
      }
    } else {
      // Already daily/weekly format
      expandedData.push(item);
    }
  });

  return expandedData;
}

function getLineChartData(grupo) {
  if (!grupo || !grupo.indicadores || grupo.indicadores.length === 0) {
    return { labels: [], datasets: [] };
  }

  const dadosIndicador = grupo.indicadores[0].dados;
  const dadosFiltrados = applyDateRangeFilter(dadosIndicador);
  const dadosExpandidos = expandDataToGranularity(dadosFiltrados);
  const labels = dadosExpandidos.map(item => item.titulo);
  const dataValues = dadosExpandidos.map(item => parseFloat(item.valor));

  // Obter meta (usar codigoOriginal se o código contém '_agrupado')
  const codigoParaMeta = grupo.codigo?.includes('_agrupado')
    ? grupo.codigoOriginal
    : grupo.codigo;
  const meta = getMeta(codigoParaMeta);

  let borderColor = 'rgba(59, 130, 246, 1)';
  let backgroundColor = 'rgba(59, 130, 246, 0.1)';

  const datasets = [
    {
      label: getIndicatorTitle(grupo.codigo),
      data: dataValues,
      borderColor: borderColor,
      backgroundColor: backgroundColor,
      fill: true,
      metaValue: meta !== null ? meta.valor : null, // Passar valor da meta para usar nos labels
      metaOperador: meta !== null ? meta.operador : null, // Passar operador da meta para usar nos labels
      segment: meta !== null ? {
        borderColor: (ctx) => {
          const p0 = ctx.p0;
          const p1 = ctx.p1;
          const metaValor = meta.valor;
          const metaOperador = meta.operador;

          // Determinar a cor baseada na posição média do segmento em relação à meta
          const y0 = p0.parsed.y;
          const y1 = p1.parsed.y;
          const mediaY = (y0 + y1) / 2;

          const metaAtingida = verificaMetaAtingida(mediaY, metaValor, metaOperador);
          return metaAtingida === true
            ? 'rgba(34, 197, 94, 1)' // Verde se meta atingida
            : 'rgba(239, 68, 68, 1)'; // Vermelho se meta não atingida
        },
        backgroundColor: (ctx) => {
          const p0 = ctx.p0;
          const p1 = ctx.p1;
          const metaValor = meta.valor;
          const metaOperador = meta.operador;

          // Determinar a cor de preenchimento baseada na posição média do segmento
          const y0 = p0.parsed.y;
          const y1 = p1.parsed.y;
          const mediaY = (y0 + y1) / 2;

          const metaAtingida = verificaMetaAtingida(mediaY, metaValor, metaOperador);
          return metaAtingida === true
            ? 'rgba(34, 197, 94, 0.1)' // Verde claro se meta atingida
            : 'rgba(239, 68, 68, 0.1)'; // Vermelho claro se meta não atingida
        }
      } : undefined,
    }
  ];

  // Adicionar linha de meta se existir
  if (meta !== null) {
    datasets.push({
      label: 'Meta',
      data: new Array(labels.length).fill(meta.valor),
      borderColor: 'rgba(156, 163, 175, 0.8)', // Cinza para a linha de meta
      backgroundColor: 'transparent',
      borderWidth: 2,
      borderDash: [5, 5], // Linha tracejada
      fill: false,
      pointRadius: 0,
      datalabels: {
        display: false
      }
    });
  }

  return {
    labels: labels,
    datasets: datasets
  };
}

function getDoughnutChartData(indicator) {
  const selectedData = getSelectedMonthData(indicator);

  if (!selectedData) return { datasets: [] };

  // Usa o valor do mês selecionado
  const valorAtual = parseFloat(selectedData.valor || 0);

  const codigoParaMeta = getCodigoParaMeta(indicator);
  const meta = getMeta(codigoParaMeta);

  let filledValue, emptyValue;
  let chartColor;

  if (meta) {
    const metaValor = meta.valor;
    let porcentagemDaMeta = 0;
    if (metaValor > 0) porcentagemDaMeta = (valorAtual / metaValor) * 100;
    filledValue = Math.min(porcentagemDaMeta, 100);
    emptyValue = 100 - filledValue;

    // Recalcula a cor baseada no mês selecionado
    const pct = meta.valor > 0 ? (valorAtual / meta.valor) * 100 : 0;

    // Verifica se bateu a meta neste mês específico
    const metaAtingidaNoMes = verificaMetaAtingida(valorAtual, meta.valor, meta.operador);

    if (meta.operador === '>' || meta.operador === '>=') {
      if (metaAtingidaNoMes) chartColor = 'rgba(16, 185, 129, 1)';
      else if (pct >= 70) chartColor = 'rgba(234, 179, 8, 1)';
      else chartColor = 'rgba(239, 68, 68, 1)';
    } else {
      if (!metaAtingidaNoMes) chartColor = 'rgba(239, 68, 68, 1)';
      else if (pct >= 70) chartColor = 'rgba(234, 179, 8, 1)';
      else chartColor = 'rgba(16, 185, 129, 1)';
    }
  } else {
    filledValue = Math.min(valorAtual, 100);
    emptyValue = 100 - filledValue;
    chartColor = 'rgba(59, 130, 246, 1)';
  }

  const isDark = document.documentElement.classList.contains('dark');
  const trackColor = (isGeneratingPDF.value || isGeneratingPPT.value || !isDark) ? 'rgba(229, 231, 235, 1)' : 'rgba(255, 255, 255, 0.1)';

  return {
    labels: ['Atingido', 'Restante'],
    datasets: [{
      data: [filledValue, emptyValue],
      backgroundColor: [chartColor, trackColor],
      borderWidth: 0,
      borderRadius: 20,
      cutout: '85%',
      hoverOffset: 0,
    }],
  };
}

function getBarChartData(grupo) {
  if (!grupo || !grupo.indicadores || grupo.indicadores.length === 0) {
    return { labels: [], datasets: [] };
  }

  const dadosIndicador = grupo.indicadores[0].dados;
  const dadosFiltrados = applyDateRangeFilter(dadosIndicador);
  const dadosExpandidos = expandDataToGranularity(dadosFiltrados);

  const labels = dadosExpandidos.map(item => item.titulo);
  const dataValues = dadosExpandidos.map(item => parseFloat(item.valor));

  // Obter meta e verificar se foi atingida (usar codigoOriginal se o código contém '_agrupado')
  const codigoParaMeta = grupo.codigo?.includes('_agrupado')
    ? grupo.codigoOriginal
    : grupo.codigo;
  const meta = getMeta(codigoParaMeta);
  const metaAtingida = isMetaAtingida(grupo);

  // Definir cor baseada na meta
  let backgroundColor = 'rgba(251, 146, 60, 0.8)';
  let hoverBackgroundColor = 'rgba(249, 115, 22, 1)';

  if (meta !== null) {
    if (metaAtingida === true) {
      backgroundColor = 'rgba(34, 197, 94, 0.8)'; // Verde
      hoverBackgroundColor = 'rgba(22, 163, 74, 1)';
    } else if (metaAtingida === false) {
      backgroundColor = 'rgba(239, 68, 68, 0.8)'; // Vermelho
      hoverBackgroundColor = 'rgba(220, 38, 38, 1)';
    }
  }

  return {
    labels: labels,
    datasets: [
      {
        label: getIndicatorTitle(grupo.codigo),
        data: dataValues,
        backgroundColor: backgroundColor,
        hoverBackgroundColor: hoverBackgroundColor,
        borderRadius: 4,
        barPercentage: 0.6,
      }
    ]
  };
}

function applyDateRangeFilter(dados) {
  const { granularity, startYear, startMonth, endYear, endMonth, startDate, endDate } = activeDateFilter.value;

  // Filtro básico (removendo SET)
  let filtrados = dados.filter(d => d.titulo !== 'SET');

  if (granularity === 'mensal' || !granularity) {
    // Lógica antiga (Mensal)
    const startDateStr = startYear && startMonth ? `${startYear}/${String(startMonth).padStart(2, '0')}` : null;
    const endDateStr = endYear && endMonth ? `${endYear}/${String(endMonth).padStart(2, '0')}` : null;

    if (!startDateStr && !endDateStr) return filtrados;

    return filtrados.filter(d => {
      const titulo = d.titulo; // Esperado YYYY/MM
      if (startDateStr && titulo < startDateStr) return false;
      if (endDateStr && titulo > endDateStr) return false;
      return true;
    });
  } else {
    // Lógica Semanal / Diário - Filtragem LOCAL
    // O backend não filtra por data, apenas retorna o snapshot mais recente.
    // Precisamos filtrar aqui com base em startDate e endDate (YYYY-MM-DD)

    if (!startDate && !endDate) return filtrados;

    const start = startDate ? new Date(startDate + 'T00:00:00') : null;
    const end = endDate ? new Date(endDate + 'T23:59:59') : null;

    return filtrados.filter(d => {
      let dataDado = null;
      const titulo = d.titulo;

      // Tentativa de parsing da data do dado
      if (titulo.includes('/')) {
        // Formato YYYY/MM -> assume dia 1
        const parts = titulo.split('/');
        if (parts.length === 2) {
          dataDado = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, 1, 12, 0, 0);
        } else if (parts.length === 3) {
          // YYYY/MM/DD ??
          dataDado = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]), 12, 0, 0);
        }
      } else if (titulo.includes('-')) {
        // YYYY-MM-DD
        dataDado = new Date(titulo + 'T12:00:00');
      }

      if (!dataDado || isNaN(dataDado.getTime())) {
        return true; // Mantém dados com formato desconhecido por segurança
      }

      if (start && dataDado < start) return false;
      if (end && dataDado > end) return false;

      return true;
    });
  }
}

function getIndicatorTitle(codigo, nomeFantasia = null) {
  // Se tiver nome fantasia, usar ele
  if (nomeFantasia?.nome_fantasia_titulo) {
    return nomeFantasia.nome_fantasia_titulo;
  }

  // Caso contrário, usar o título padrão
  const cleanCode = codigo.replace(/_\d+$/, '');

  const matchCCDTI = cleanCode.match(/^Variavel_(\d+)_-_Indicador_(\d+)/);
  if (matchCCDTI && matchCCDTI[1] && matchCCDTI[2]) {
    return `Variavel ${matchCCDTI[1]} Indicador ${matchCCDTI[2]}`;
  }

  const matchAvancada = cleanCode.match(/^Indicador_(\d+)_-_Sint[eé]tico/);
  if (matchAvancada && matchAvancada[1]) {
    return `Indicador ${matchAvancada[1]}`;
  }

  return "Indicador";
}

function getIndicatorDescription(codigo, nomeFantasia = null) {
  // Se tiver nome fantasia, usar ele
  if (nomeFantasia?.nome_fantasia_descricao) {
    return nomeFantasia.nome_fantasia_descricao;
  }

  // Remove '_agrupado' ANTES de remover o sufixo numérico
  const cleanCode = codigo.replace('_agrupado', '').replace(/_\d+$/, '');

  const match = cleanCode.match(/Indicador_\d+_-_Sint[eé]tico\s*(.*)/);

  if (match && match[1]) {
    return match[1].trim();
  }

  return "";
}

function getOriginalTitle(codigo) {
  const cleanCode = codigo.replace(/_\d+$/, '');

  const matchCCDTI = cleanCode.match(/^Variavel_(\d+)_-_Indicador_(\d+)/);
  if (matchCCDTI && matchCCDTI[1] && matchCCDTI[2]) {
    return `Variavel ${matchCCDTI[1]} Indicador ${matchCCDTI[2]}`;
  }

  const matchAvancada = cleanCode.match(/^Indicador_(\d+)_-_Sint[eé]tico/);
  if (matchAvancada && matchAvancada[1]) {
    return `Indicador ${matchAvancada[1]}`;
  }

  return "Indicador";
}

function getOriginalDescription(codigo) {
  const cleanCode = codigo.replace(/_\d+$/, '');

  const match = cleanCode.match(/Indicador_\d+_-_Sint[eé]tico\s*(.*)/);

  if (match && match[1]) {
    return match[1].trim();
  }

  return "";
}

async function saveNomeFantasia(codigoOriginal, tipo) {
  try {
    const codigo = codigoOriginal.replace(/_\d+$/, '');
    const value = tipo === 'titulo'
      ? editTitleValue.value[codigoOriginal]
      : editDescriptionValue.value[codigoOriginal];

    const payload = {};
    if (tipo === 'titulo') {
      payload.nome_fantasia_titulo = value || null;
    } else {
      payload.nome_fantasia_descricao = value || null;
    }

    await apiClient.patch(`/api/v1/indicadores/nome-fantasia/${codigo}/`, payload);

    // Atualizar os dados locais
    const grupo = indicatorsRawData.value.find(g => g.codigo === codigo);
    if (grupo) {
      if (!grupo.nome_fantasia) {
        grupo.nome_fantasia = {};
      }
      if (tipo === 'titulo') {
        grupo.nome_fantasia.nome_fantasia_titulo = value || null;
      } else {
        grupo.nome_fantasia.nome_fantasia_descricao = value || null;
      }
    }

    // Sair do modo de edição
    if (tipo === 'titulo') {
      editingTitle.value[codigoOriginal] = false;
    } else {
      editingDescription.value[codigoOriginal] = false;
    }

    // Recarregar indicadores para garantir sincronização
    await fetchIndicators();
  } catch (err) {
    console.error("Erro ao salvar nome fantasia:", err);
    alert("Erro ao salvar nome fantasia. Por favor, tente novamente.");
  }
}

function startEditing(codigoOriginal, tipo) {
  if (!codigoOriginal) {
    console.error('codigoOriginal não definido');
    return;
  }

  const codigo = codigoOriginal.replace(/_\d+$/, '');

  if (tipo === 'titulo') {
    // Criar novo objeto para garantir reatividade
    editingTitle.value = {
      ...editingTitle.value,
      [codigoOriginal]: true
    };
    const grupo = indicatorsRawData.value.find(g => g.codigo === codigo);
    const valorAtual = grupo?.nome_fantasia?.nome_fantasia_titulo || getOriginalTitle(codigo);
    editTitleValue.value = {
      ...editTitleValue.value,
      [codigoOriginal]: valorAtual
    };
  } else {
    // Criar novo objeto para garantir reatividade
    editingDescription.value = {
      ...editingDescription.value,
      [codigoOriginal]: true
    };
    const grupo = indicatorsRawData.value.find(g => g.codigo === codigo);
    const valorAtual = grupo?.nome_fantasia?.nome_fantasia_descricao || getOriginalDescription(codigo);
    editDescriptionValue.value = {
      ...editDescriptionValue.value,
      [codigoOriginal]: valorAtual
    };
  }
}

function cancelEditing(codigoOriginal, tipo) {
  if (tipo === 'titulo') {
    const newEditing = { ...editingTitle.value };
    delete newEditing[codigoOriginal];
    editingTitle.value = newEditing;

    const newValue = { ...editTitleValue.value };
    delete newValue[codigoOriginal];
    editTitleValue.value = newValue;
  } else {
    const newEditing = { ...editingDescription.value };
    delete newEditing[codigoOriginal];
    editingDescription.value = newEditing;

    const newValue = { ...editDescriptionValue.value };
    delete newValue[codigoOriginal];
    editDescriptionValue.value = newValue;
  }
}

function getIndicatorSortKeys(codigo) {
  const cleanCode = codigo.replace(/_\d+$/, '');

  const matchCCDTI = cleanCode.match(/^Variavel_(\d+)_-_Indicador_(\d+)/);
  if (matchCCDTI && matchCCDTI[1] && matchCCDTI[2]) {
    return {
      vNum: parseInt(matchCCDTI[1], 10),
      iNum: parseInt(matchCCDTI[2], 10)
    };
  }

  const matchAvancada = cleanCode.match(/^Indicador_(\d+)_-_Sint[eé]tico/);
  if (matchAvancada && matchAvancada[1]) {
    return {
      vNum: 0,
      iNum: parseInt(matchAvancada[1], 10)
    };
  }

  return { vNum: 999, iNum: 999 };
}

// Funções para metas dos indicadores CCDTI e Avançadas
function getVariavelAndIndicador(codigo) {
  const cleanCode = codigo.replace(/_\d+$/, '');
  const matchCCDTI = cleanCode.match(/^Variavel_(\d+)_-_Indicador_(\d+)/);
  if (matchCCDTI && matchCCDTI[1] && matchCCDTI[2]) {
    return {
      variavel: parseInt(matchCCDTI[1], 10),
      indicador: parseInt(matchCCDTI[2], 10),
      tipo: 'CCDTI'
    };
  }
  return null;
}

function getIndicadorAvancada(codigo) {
  const cleanCode = codigo.replace(/_\d+$/, '');
  const matchAvancada = cleanCode.match(/^Indicador_(\d+)_-_Sint[eé]tico/);
  if (matchAvancada && matchAvancada[1]) {
    return {
      indicador: parseInt(matchAvancada[1], 10),
      tipo: 'Avançadas'
    };
  }
  return null;
}

function getMeta(codigo) {
  // Verificar se é indicador CCDTI
  const infoCCDTI = getVariavelAndIndicador(codigo);
  if (infoCCDTI) {
    const { variavel, indicador } = infoCCDTI;

    // Metas CCDTI definidas conforme especificação
    if (variavel === 1 && indicador === 1) {
      // Índice de absenteísmo: < 3%
      return { valor: 3, operador: '<' };
    }
    if (variavel === 1 && indicador === 2) {
      // Taxa de turnover: ≤ 3,5
      return { valor: 3.5, operador: '<=' };
    }
    if (variavel === 1 && indicador === 3) {
      // Educação permanente: 1,5 homem treinado mês
      return { valor: 1.5, operador: '>=' };
    }
    if (variavel === 1 && indicador === 5) {
      // Resolubilidade da ouvidoria: ≥ 90%
      return { valor: 90, operador: '>=' };
    }
    if (variavel === 3 && indicador === 1) {
      // Meta: > 15%
      return { valor: 15, operador: '>' };
    }
    if (variavel === 3 && indicador === 2) {
      // Meta: > 85%
      return { valor: 85, operador: '>' };
    }
  }

  // Verificar se é indicador Avançadas
  const infoAvancada = getIndicadorAvancada(codigo);
  if (infoAvancada) {
    const { indicador } = infoAvancada;

    // Metas Avançadas definidas conforme especificação
    if (indicador === 1) {
      return { valor: 80, operador: '>=' }; // Indicador 1: 80%
    }
    if (indicador === 2) {
      return { valor: 5, operador: '>=' }; // Indicador 2: 5%
    }
    if (indicador === 3) {
      return { valor: 90, operador: '>=' }; // Indicador 3: 90%
    }
    if (indicador === 4) {
      return { valor: 90, operador: '>=' }; // Indicador 4: 90%
    }
    if (indicador === 5) {
      return { valor: 5, operador: '<=' }; // Indicador 5: ≤ 5%
    }
    if (indicador === 6) {
      return { valor: 70, operador: '>=' }; // Indicador 6: ≥ 70%
    }
    if (indicador === 7) {
      return { valor: 7, operador: '<=' }; // Indicador 7: ≤ 7%
    }
    if (indicador === 9) {
      return { valor: 85, operador: '>=' }; // Indicador 9: ≥ 85%
    }
    if (indicador === 10) {
      return { valor: 15, operador: '>=' }; // Indicador 10: ≥ 15%
    }
  }

  return null;
}

function getCurrentValue(indicator) {
  if (!indicator) return null;

  // Usar o último valor recebido do backend (sem filtros)
  if (indicator.indicadores && indicator.indicadores[0] && indicator.indicadores[0].dados) {
    const dadosOriginais = indicator.indicadores[0].dados;
    // Filtrar apenas para remover 'SET' e pegar o último valor real recebido
    const dadosValidos = dadosOriginais.filter(d => d.titulo !== 'SET');
    if (dadosValidos.length > 0) {
      // Pegar o último valor do array original (último mês recebido do backend)
      const ultimoItem = dadosValidos[dadosValidos.length - 1];
      const ultimoValor = parseFloat(ultimoItem.valor);
      if (!isNaN(ultimoValor)) return ultimoValor;
    }
  }

  return null;
}


// Função helper para verificar se valor atinge a meta baseado no operador
function verificaMetaAtingida(valor, metaValor, operador) {
  if (valor === null || valor === undefined || isNaN(valor)) return null;
  if (metaValor === null || metaValor === undefined || isNaN(metaValor)) return null;

  switch (operador) {
    case '<':
      return valor < metaValor; // Meta: < 3%, atingida se valor < 3
    case '<=':
      return valor <= metaValor; // Meta: <= 3.5%, atingida se valor <= 3.5
    case '>':
      return valor > metaValor; // Meta: > 15%, atingida se valor > 15
    case '>=':
      return valor >= metaValor; // Meta: >= 90%, atingida se valor >= 90
    default:
      return null;
  }
}

// Função auxiliar para obter o código correto para buscar a meta
function getCodigoParaMeta(indicator) {
  // Usar codigoOriginal se o código contém '_agrupado', senão usar codigo
  return indicator.codigo?.includes('_agrupado')
    ? indicator.codigoOriginal
    : indicator.codigo;
}

function isMetaAtingida(indicator) {
  const codigoParaMeta = getCodigoParaMeta(indicator);
  const meta = getMeta(codigoParaMeta);
  if (!meta) return null; // Sem meta definida

  const valorAtual = getCurrentValue(indicator);
  if (valorAtual === null) return null;

  return verificaMetaAtingida(valorAtual, meta.valor, meta.operador);
}

function formatMeta(meta, codigo = null) {
  if (!meta) return '';

  const { valor, operador } = meta;
  let operadorSymbol = '';

  switch (operador) {
    case '<':
      operadorSymbol = '<';
      break;
    case '<=':
      operadorSymbol = '≤';
      break;
    case '>':
      operadorSymbol = '>';
      break;
    case '>=':
      operadorSymbol = '≥';
      break;
    default:
      operadorSymbol = '';
  }

  // Determinar se precisa de % baseado no indicador
  // Educação permanente (Variável 1, Indicador 3) não usa %
  let needsPercent = true;
  if (codigo) {
    const info = getVariavelAndIndicador(codigo);
    if (info && info.variavel === 1 && info.indicador === 3) {
      needsPercent = false;
    }
  }

  return `${operadorSymbol} ${valor}${needsPercent ? '%' : ''}`;
}

function getChartColor(darkThemeColor, lightThemeColor) {
  // Se estiver gerando PDF, força sempre a cor do modo claro (escrita escura)
  if (isGeneratingPDF.value || isGeneratingPPT.value) {
    return lightThemeColor;
  }

  // Se não for PDF, verifica se o modo noturno está ativo no navegador
  const isDark = document.documentElement.classList.contains('dark');
  return isDark ? darkThemeColor : lightThemeColor;
}

const carregarRelatorio = async () => {
  carregandoRelatorio.value = true;
  dadosRelatorio.value = null; // Limpa dados anteriores

  try {
    const params = {};

    // Filtro de Tipo
    if (activeTypeFilter.value) {
      params.tipo = activeTypeFilter.value;
    }

    // Filtro de Unidade (apenas se for Avançadas e tiver selecionado)
    if (activeTypeFilter.value === 'Avançadas' && activeUnitFilter.value) {
      params.unidade_id = activeUnitFilter.value;
    }

    // Filtro de Data
    const { startYear, startMonth, endYear, endMonth } = activeDateFilter.value;

    if (startYear && startMonth) {
      params.start_date = `${startYear}-${String(startMonth).padStart(2, '0')}-01`;
    }

    if (endYear && endMonth) {
      const lastDay = new Date(endYear, endMonth, 0).getDate();
      params.end_date = `${endYear}-${String(endMonth).padStart(2, '0')}-${lastDay}`;
    }

    console.log("Enviando requisição de relatório com params:", params);

    const response = await apiClient.get('/api/v1/indicadores/relatorio/dados/', { params });

    let dadosRecebidos = response.data;

    // Aplicar filtro de busca no frontend
    if (searchQuery.value && dadosRecebidos.indicadores) {
      const query = normalizeString(searchQuery.value);

      dadosRecebidos.indicadores = dadosRecebidos.indicadores.filter(ind => {
        // Normalizar campos para busca
        const codigo = normalizeString(ind.codigo || '');

        // Tentar obter título e descrição usando as funções auxiliares se possível, 
        // ou usar os campos diretos do objeto do relatório
        const titulo = normalizeString(
          ind.nome_fantasia_titulo ||
          getIndicatorTitle(ind.codigo, ind.nome_fantasia) ||
          ind.titulo ||
          ''
        );

        const descricao = normalizeString(
          ind.nome_fantasia_descricao ||
          getIndicatorDescription(ind.codigo, ind.nome_fantasia) ||
          ind.descricao ||
          ''
        );

        return codigo.includes(query) || titulo.includes(query) || descricao.includes(query);
      });
    }

    dadosRelatorio.value = dadosRecebidos;

  } catch (error) {
    console.error('Erro ao carregar relatório:', error);
    alert('Erro ao carregar relatório. Verifique o console.');
  } finally {
    carregandoRelatorio.value = false;
  }
};

const gerarPDF = async () => {
  if (!dadosRelatorio.value || !dadosRelatorio.value.indicadores || dadosRelatorio.value.indicadores.length === 0) {
    alert("Não há dados para gerar o relatório.");
    return;
  }

  isGeneratingPDF.value = true;

  // Forçar atualização dos gráficos para Modo Claro 
  await nextTick();

  // Percorre todos os gráficos e manda atualizar
  Object.values(chartRefs.value).forEach(component => {
    if (component && component.chart) {
      component.chart.update();
    }
  });

  // Pequeno delay para garantir que o canvas foi repintado
  await new Promise(resolve => setTimeout(resolve, 300));

  try {
    let nomeUsuario = 'Usuário do Sistema';
    try {
      const userStore = useUserStore();
      if (userStore.nome) nomeUsuario = userStore.nome;
    } catch (e) { console.warn("UserStore n/d"); }

    const doc = new jsPDF('landscape', 'mm', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 15;
    const tableWidth = pageWidth - (margin * 2);

    // LOGO
    let logoBase64 = null;
    try {
      const logoModule = await import('@/assets/ccdlogo.png');
      const logoUrl = logoModule.default || logoModule;
      const response = await fetch(logoUrl);
      const blob = await response.blob();
      logoBase64 = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    } catch (logoError) { console.log('Erro logo:', logoError); }

    // HEADER
    const drawHeader = (startY) => {
      let cursorY = startY;
      const logoWidth = 60;
      const logoHeight = 20;
      const contentWidth = logoWidth + 80;
      const startX = (pageWidth - contentWidth) / 2;

      if (logoBase64) doc.addImage(logoBase64, 'PNG', startX, cursorY, logoWidth, logoHeight);

      doc.setDrawColor(200, 200, 200); doc.setLineWidth(0.5);
      doc.line(startX + logoWidth + 5, cursorY, startX + logoWidth + 5, cursorY + logoHeight);

      doc.setFontSize(16); doc.setFont(undefined, 'bold'); doc.setTextColor(30, 58, 138);
      doc.text('Relatório de Indicadores', startX + logoWidth + 10, cursorY + 10);

      let subTitle = '';
      if (activeTypeFilter.value === 'CCDTI') subTitle = 'CCDTI';
      else if (activeTypeFilter.value === 'Avançadas') subTitle = 'Avançadas';

      if (subTitle) {
        doc.setFontSize(12); doc.setFont(undefined, 'normal'); doc.setTextColor(100, 116, 139);
        doc.text(subTitle, startX + logoWidth + 10, cursorY + 16);
      }

      cursorY += logoHeight + 8;
      doc.setDrawColor(59, 130, 246); doc.setLineWidth(0.5);
      doc.line(margin, cursorY, pageWidth - margin, cursorY);

      return cursorY + 8;
    };

    // INÍCIO
    let currentY = margin;
    currentY = drawHeader(currentY);

    // RESUMO
    const infoBoxY = currentY;
    const infoBoxHeight = 20;

    doc.setFillColor(240, 245, 255); doc.roundedRect(margin, infoBoxY, tableWidth, infoBoxHeight, 3, 3, 'F');
    doc.setFontSize(10); doc.setTextColor(30, 58, 138); doc.setFont(undefined, 'bold');
    doc.text('Resumo do Relatório', margin + 5, infoBoxY + 6);

    doc.setFontSize(9); doc.setTextColor(0, 0, 0); doc.setFont(undefined, 'normal');
    doc.text(`Data: ${new Date().toLocaleString('pt-BR')}`, margin + 5, infoBoxY + 12);
    doc.text(`Registros: ${dadosRelatorio.value.total}`, margin + 70, infoBoxY + 12);
    doc.text(`Usuário: ${nomeUsuario}`, margin + 5, infoBoxY + 17);

    const filtros = dadosRelatorio.value.filtros_aplicados || {};
    let filtrosTexto = [];
    if (filtros.tipo) filtrosTexto.push(`Tipo - ${filtros.tipo}`);
    if (filtros.unidade_id) {
      const idParaBuscar = activeUnitFilter.value || filtros.unidade_id;
      const unidadeEncontrada = availableUnits.value.find(u => u.id == idParaBuscar);
      const nomeUnidade = unidadeEncontrada ? unidadeEncontrada.nome : idParaBuscar;
      filtrosTexto.push(`Unidade - ${nomeUnidade}`);
    }
    if (filtros.codigo) filtrosTexto.push(`Busca - "${filtros.codigo}"`);
    doc.text(filtrosTexto.length > 0 ? `Filtros: ${filtrosTexto.join(' | ')}` : 'Filtros: Todos', margin + 70, infoBoxY + 17);

    currentY += infoBoxHeight + 5;

    // CONTROLE DE MODO
    const showTable = reportMode.value === 'ambos' || reportMode.value === 'tabela';
    const showCharts = reportMode.value === 'ambos' || reportMode.value === 'graficos';
    let sectionNumber = 1;

    // TABELA
    if (showTable) {
      if (reportMode.value === 'ambos') {
        currentY += 8;

        doc.setFontSize(14); doc.setTextColor(30, 58, 138); doc.setFont(undefined, 'bold');
        doc.text(`${sectionNumber}. Detalhamento em Tabela`, margin, currentY);
        sectionNumber++;
        currentY += 8;
      } else {
        currentY += 5;
      }

      let linhasTabela = [];
      dadosRelatorio.value.indicadores.forEach(ind => {
        let titulo = getIndicatorTitle(ind.codigo);
        if (activeTypeFilter.value === 'Avançadas') {
          const desc = getIndicatorDescription(ind.codigo);
          if (desc) titulo += ` - ${desc}`;
        }
        const unidade = ind.unidade_nome || '-';
        // Aplica o filtro de data (activeDateFilter) nos dados brutos antes de gerar as linhas
        const dadosFiltrados = applyDateRangeFilter(ind.dados || []);
        dadosFiltrados.forEach(dado => {
          if (dado.titulo === 'SET') return;
          let valorStr = dado.valor;
          const valNum = parseFloat(dado.valor);
          if (!isNaN(valNum)) valorStr = valNum.toFixed(2) + '%';
          linhasTabela.push([titulo.substring(0, 50), unidade, dado.titulo, dado.numerador || '-', dado.denominador || '-', valorStr]);
        });
      });

      const headers = ['Indicador', 'Unidade', 'Período', 'Num.', 'Den.', 'Valor'];
      const colWidths = [110, 40, 30, 30, 30, 30];
      const rowHeight = 7;
      const headerHeight = 8;

      let tableY = currentY;
      const drawTableHeader = (y) => {
        doc.setFillColor(30, 58, 138); doc.roundedRect(margin, y, tableWidth, headerHeight, 2, 2, 'F');
        doc.setTextColor(255, 255, 255); doc.setFontSize(9); doc.setFont(undefined, 'bold');
        let xPos = margin + 3;
        headers.forEach((header, index) => {
          doc.text(header, xPos, y + 5.5); xPos += colWidths[index];
        });
      };

      drawTableHeader(tableY); tableY += headerHeight;
      doc.setTextColor(0, 0, 0); doc.setFont(undefined, 'normal'); doc.setFontSize(8);

      for (let i = 0; i < linhasTabela.length; i++) {
        if (tableY > pageHeight - 35) {
          doc.addPage(); tableY = margin; tableY = drawHeader(tableY); tableY += 5;
          drawTableHeader(tableY); tableY += headerHeight;
          doc.setTextColor(0, 0, 0); doc.setFont(undefined, 'normal'); doc.setFontSize(8);
        }
        if (i % 2 === 0) { doc.setFillColor(249, 250, 251); doc.rect(margin, tableY, tableWidth, rowHeight, 'F'); }
        let xPos = margin + 3;
        linhasTabela[i].forEach((texto, index) => {
          doc.text(String(texto), xPos, tableY + 4.5); xPos += colWidths[index];
        });
        doc.setDrawColor(230, 230, 230); doc.line(margin, tableY + rowHeight, pageWidth - margin, tableY + rowHeight);
        tableY += rowHeight;
      }
      currentY = tableY;
    }

    // GRÁFICOS
    const indicatorsToList = filteredIndicators.value;

    if (showCharts && indicatorsToList.length > 0) {

      if (showTable) {
        doc.addPage(); currentY = margin; currentY = drawHeader(currentY);
      } else {
        if (currentY > pageHeight - 40) {
          doc.addPage(); currentY = margin; currentY = drawHeader(currentY);
        } else {
          currentY += 2;
        }
      }

      let contentStartY;

      if (reportMode.value === 'ambos') {
        doc.setFontSize(14); doc.setTextColor(30, 58, 138); doc.setFont(undefined, 'bold');
        doc.text(`${sectionNumber}. Painel Visual de Indicadores`, margin, currentY + 8);
        contentStartY = currentY + 15;
      } else {
        contentStartY = currentY + 2;
      }

      const chartWidth = (pageWidth - (margin * 3)) / 2;
      const chartHeight = 58;
      const textHeight = 40;
      const boxHeight = chartHeight + textHeight + 5;

      for (let i = 0; i < indicatorsToList.length; i++) {
        const indicator = indicatorsToList[i];

        if (i > 0 && i % 2 === 0) {
          doc.addPage(); let chartY = margin; chartY = drawHeader(chartY);
          contentStartY = chartY + 5;
        }

        const isLeft = i % 2 === 0;
        const xPos = isLeft ? margin : margin + chartWidth + margin;
        const yPos = contentStartY;

        doc.setFillColor(252, 252, 252); doc.setDrawColor(230, 230, 230);
        doc.roundedRect(xPos, yPos, chartWidth, boxHeight, 3, 3, 'FD');

        doc.setFontSize(10); doc.setTextColor(30, 58, 138); doc.setFont(undefined, 'bold');
        const titulo = getIndicatorTitle(indicator.codigo, indicator.nome_fantasia).replace('_agrupado', '');
        const splitTitle = doc.splitTextToSize(titulo, chartWidth - 10);
        doc.text(splitTitle, xPos + 5, yPos + 8);
        let currentTextY = yPos + 8 + (splitTitle.length * 4);

        const unidadeNome = indicator.indicadores[0]?.unidade_nome;
        const isAvancadas = activeTypeFilter.value === 'Avançadas';
        if (isAvancadas && unidadeNome) {
          const lastLine = splitTitle[splitTitle.length - 1];
          const lastLineWidth = doc.getTextWidth(lastLine);
          const badgeTextWidth = doc.getTextWidth(unidadeNome);
          const badgeWidth = badgeTextWidth + 4;
          let badgeX = xPos + 5 + lastLineWidth + 2;
          let badgeY = yPos + 8 + ((splitTitle.length - 1) * 4) - 3.5;
          if (badgeX + badgeWidth > xPos + chartWidth - 2) {
            badgeX = xPos + 5; badgeY = currentTextY - 1; currentTextY += 6;
          }
          doc.setFillColor(219, 234, 254); doc.setDrawColor(191, 219, 254);
          doc.roundedRect(badgeX, badgeY, badgeWidth, 5, 1.5, 1.5, 'FD');
          doc.setTextColor(30, 64, 175); doc.setFontSize(8);
          doc.text(unidadeNome, badgeX + 2, badgeY + 3.5);
          doc.setTextColor(30, 58, 138); doc.setFontSize(10);
        }
        currentTextY += 2;

        if (unidadeNome !== 'Todas as unidades') {
          const descricao = getIndicatorDescription(indicator.codigo, indicator.nome_fantasia).replace('_agrupado', '');
          if (descricao) {
            doc.setFontSize(8); doc.setTextColor(80, 80, 80); doc.setFont(undefined, 'normal');
            const splitDesc = doc.splitTextToSize(descricao, chartWidth - 10);
            doc.text(splitDesc, xPos + 5, currentTextY);
            currentTextY += (splitDesc.length * 3.5);
          }
        }
        currentTextY += 2;


        const cardHeight = 14;
        const cardY = currentTextY;
        doc.setFillColor(239, 246, 255); doc.setDrawColor(219, 234, 254);
        doc.roundedRect(xPos + 5, cardY, chartWidth - 10, cardHeight, 2, 2, 'FD');

        const valorAtual = getCurrentValue(indicator);
        const metaAtingida = isMetaAtingida(indicator);
        const metaObj = getMeta(getCodigoParaMeta(indicator));

        doc.setFontSize(7); doc.setTextColor(100, 116, 139); doc.setFont(undefined, 'normal');
        doc.text("Valor Atual (Último Mês)", xPos + 8, cardY + 4.5);
        doc.setFontSize(12); doc.setFont(undefined, 'bold');

        if (metaObj !== null) {
          if (metaAtingida === true) doc.setTextColor(22, 163, 74);
          else if (metaAtingida === false) doc.setTextColor(220, 38, 38);
          else doc.setTextColor(37, 99, 235);
        } else doc.setTextColor(37, 99, 235);
        const valorTexto = valorAtual !== null ? valorAtual.toFixed(2) + '%' : 'N/A';
        doc.text(valorTexto, xPos + 8, cardY + 10.5);

        if (metaObj !== null) {
          doc.setFontSize(7); doc.setTextColor(100, 116, 139); doc.setFont(undefined, 'normal');
          doc.text("Meta", xPos + chartWidth - 8, cardY + 4.5, { align: 'right' });
          doc.setFontSize(11); doc.setTextColor(51, 65, 85); doc.setFont(undefined, 'bold');
          let metaTexto = formatMeta(metaObj, getCodigoParaMeta(indicator)).replace('≤', '<=').replace('≥', '>=');
          doc.text(metaTexto, xPos + chartWidth - 8, cardY + 10.5, { align: 'right' });
        }
        currentTextY += cardHeight + 4;

        const chartComponent = chartRefs.value[indicator.codigo];
        if (chartComponent && chartComponent.chart) {
          try {
            const isDoughnut = getIndicatorMode(indicator.codigo) === 'doughnut';
            const imgData = chartComponent.chart.toBase64Image();
            const maxImgWidth = chartWidth - 4;
            const maxImgHeight = isDoughnut ? 42 : chartHeight;

            const ratio = chartComponent.chart.width / chartComponent.chart.height;

            let finalImgWidth = maxImgWidth;
            let finalImgHeight = finalImgWidth / ratio;

            if (finalImgHeight > maxImgHeight) {
              finalImgHeight = maxImgHeight;
              finalImgWidth = finalImgHeight * ratio;
            }

            const offsetX = (maxImgWidth - finalImgWidth) / 2;
            const paddingY = isDoughnut ? 2 : 0;

            const chartX = xPos + 2 + offsetX;
            const chartY = currentTextY + paddingY;

            doc.addImage(imgData, 'PNG', chartX, chartY, finalImgWidth, finalImgHeight, undefined, 'FAST');

            if (isDoughnut) {
              const centerX = chartX + (finalImgWidth / 2);
              const centerY = chartY + (finalImgHeight / 2);
              const metaObj = getMeta(getCodigoParaMeta(indicator));
              const valAtual = getCurrentValue(indicator);
              const metaAtingida = isMetaAtingida(indicator);

              doc.setFontSize(12);
              doc.setFont(undefined, 'bold');

              // Lógica de cor baseada na meta
              if (metaObj) {
                const pct = metaObj.valor > 0 ? (valAtual / metaObj.valor) * 100 : 0;

                if (metaObj.operador === '>' || metaObj.operador === '>=') {
                  // Maior é Melhor
                  if (metaAtingida) doc.setTextColor(22, 163, 74);       // Verde
                  else if (pct >= 70) doc.setTextColor(202, 138, 4);     // Amarelo Escuro 
                  else doc.setTextColor(220, 38, 38);                    // Vermelho
                } else {
                  // Menor é Melhor
                  if (!metaAtingida) doc.setTextColor(220, 38, 38);      // Vermelho
                  else if (pct >= 70) doc.setTextColor(202, 138, 4);     // Amarelo
                  else doc.setTextColor(22, 163, 74);                    // Verde
                }
              } else {
                doc.setTextColor(37, 99, 235); // Azul
              }

              let textoCentro = '';
              let textoSub = '';

              if (metaObj) {
                const pctMeta = metaObj.valor > 0 ? (valAtual / metaObj.valor) * 100 : 0;
                textoCentro = pctMeta.toFixed(0) + '%';
                textoSub = 'DA META';
              } else {
                textoCentro = (valAtual?.toFixed(1) || '0.0') + '%';
                textoSub = 'REALIZADO';
              }

              doc.text(textoCentro, centerX, centerY - 2, { align: 'center', baseline: 'middle' });

              doc.setFontSize(7);
              doc.setTextColor(107, 114, 128);
              doc.setFont(undefined, 'bold');
              doc.text(textoSub, centerX, centerY + 3, { align: 'center', baseline: 'middle' });

              const resumoY = chartY + finalImgHeight + 8;

              doc.setFontSize(8);
              doc.setTextColor(107, 114, 128);
              doc.setFont(undefined, 'bold');

              let textoResumo = metaObj
                ? `${valAtual?.toFixed(2)}% / ${metaObj.valor}%`
                : `${valAtual?.toFixed(2)}%`;

              doc.text(textoResumo, centerX, resumoY, { align: 'center' });

              const labelBottom = metaObj ? 'ATUAL (ÚLTIMO MÊS) VS META' : 'VALOR ATUAL (ÚLTIMO MÊS)';
              doc.setFontSize(7);
              doc.setTextColor(156, 163, 175);
              doc.setFont(undefined, 'normal');
              doc.text(labelBottom, centerX, resumoY + 4, { align: 'center' });
            }

          } catch (err) { console.error(err); }
        } else {
          doc.setFontSize(9); doc.setTextColor(150, 150, 150);
          doc.text("Gráfico indisponível", xPos + 5, yPos + 60);
        }
      }
    }

    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      const footerY = pageHeight - margin;
      doc.setDrawColor(100, 100, 100); doc.setLineWidth(0.5);
      doc.line(margin, footerY - 5, pageWidth - margin, footerY - 5);
      doc.setFontSize(8); doc.setTextColor(60, 60, 60); doc.setFont(undefined, 'bold');
      const labelText = "Fonte dos indicadores: ";
      doc.text(labelText, margin, footerY);
      const labelWidth = doc.getTextWidth(labelText);
      doc.setFont(undefined, 'normal');
      doc.text("Prontuário Eletrônico da Medilab Sistemas", margin + labelWidth, footerY);
      doc.text(`Página ${i} de ${totalPages}`, pageWidth - margin, footerY, { align: 'right' });
    }

    const pdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl, '_blank');
    setTimeout(() => URL.revokeObjectURL(pdfUrl), 100);

  } catch (error) {
    console.error('Erro ao gerar PDF:', error);
    alert('Erro ao gerar PDF.');
  } finally {
    isGeneratingPDF.value = false;

    // Restaurar cores originais (Modo Escuro se estiver ativo)
    await nextTick();
    Object.values(chartRefs.value).forEach(component => {
      if (component && component.chart) {
        component.chart.update();
      }
    });
  }
};

const gerarPPT = async () => {
  // Verifica se tem dados
  if (!dadosRelatorio.value || !dadosRelatorio.value.indicadores) return;

  isGeneratingPPT.value = true;

  try {
    // Força atualização dos gráficos (necessário para aplicar a cor cinza da rosca)
    await nextTick();
    Object.values(chartRefs.value).forEach(c => c && c.chart && c.chart.update());
    // Delay para garantir renderização do Chart.js
    await new Promise(resolve => setTimeout(resolve, 300));

    const pptx = new PptxGenJS();
    pptx.layout = 'LAYOUT_16x9';

    // CAPA
    let slide = pptx.addSlide();
    slide.background = { color: 'FFFFFF' };

    slide.addText('RELATÓRIO DE INDICADORES', {
      x: 0.5, y: '45%', w: '90%', fontFace: 'Segoe UI Variable Small', fontSize: 40, bold: true, color: '1E3A8A', align: 'center'
    });

    if (activeTypeFilter.value) {
      slide.addText(`${activeTypeFilter.value}`, {
        x: 0.5, y: '55%', w: '90%', fontFace: 'Segoe UI Variable Small', charSpacing: 2, fontSize: 18, color: '1E3A8A', align: 'center'
      });
    }

    slide.addText(`FONTE: Prontuário Eletrônico da Medilab Sistemas. Extraído em: ${new Date().toLocaleDateString('pt-BR')}`, {
      x: 0.3, y: '92%', w: '60%', fontFace: 'Lucida Sans', fontSize: 10, color: '1E3A8A', align: 'left'
    });

    slide.addImage({
      path: logoSaude,
      x: '76%',
      y: '87%',
      w: 2.0,
      h: 0.4
    });


    // SLIDES DE GRÁFICOS
    const indicatorsToList = filteredIndicators.value;

    for (const indicator of indicatorsToList) {
      slide = pptx.addSlide();

      const isCCDTI = activeTypeFilter.value === 'CCDTI';
      const dynamicW = isCCDTI ? '42%' : '25%';

      // CABEÇALHO
      const titulo = getIndicatorTitle(indicator.codigo, indicator.nome_fantasia).toUpperCase();
      slide.addText(titulo, {
        x: 0.3, y: '6%', w: dynamicW, h: 0.3, fontFace: 'Segoe UI Variable Small', fontSize: 20, bold: true, color: '1E3A8A', align: 'left'
      });

      let currentY = 0.7;

      // Subtítulo (Unidade)
      if (indicator.indicadores[0]?.unidade_nome) {
        slide.addText(indicator.indicadores[0].unidade_nome.toUpperCase(), {
          x: dynamicW,
          y: '6%',
          w: 2.0,
          h: 0.3,
          fontSize: 10.5,
          bold: true,
          align: 'center',

          // Estilização do Badge
          color: '1E40AF',
          shape: 'roundRect',
          fill: { color: 'DBEAFE' },
          line: { type: 'none' },
          rectRadius: 0.05
        });

        currentY += 0.3;
      }

      // Descrição
      const desc = getIndicatorDescription(indicator.codigo, indicator.nome_fantasia);
      if (desc) {
        slide.addText(desc, {
          x: 0.3, y: currentY, w: '95%', fontFace: 'Lucida Sans', fontSize: 14, color: '1E3A8A'
        });
        currentY += 0.35;
      }

      slide.addText(`FONTE: Prontuário Eletrônico da Medilab Sistemas. Extraído em: ${new Date().toLocaleDateString('pt-BR')}`, {
        x: 0.3, y: '92%', w: '60%', fontFace: 'Lucida Sans', fontSize: 10, color: '1E3A8A', align: 'left'
      });

      slide.addImage({
        path: logoSaude,
        x: '76%',
        y: '87%',
        w: 2.0,
        h: 0.4
      });

      // TABELA DE DADOS (KPIs)
      currentY += 0.1; // Espaço antes da tabela

      const valAtual = getCurrentValue(indicator);
      const metaObj = getMeta(getCodigoParaMeta(indicator));
      const metaAtingida = isMetaAtingida(indicator);

      const colorGreen = '16A34A';
      const colorRed = 'DC2626';
      const colorBlue = '1E3A8A';
      const colorHeaderBg = 'DBEAFE';

      let valColor = colorBlue;
      if (metaObj !== null) {
        valColor = metaAtingida === true ? colorGreen : (metaAtingida === false ? colorRed : colorBlue);
      }
      const textoValor = valAtual !== null ? `${valAtual.toFixed(2)}%` : 'N/A';

      // 2. Definição do Texto da Meta
      let textoMeta = '-';
      if (metaObj) {
        textoMeta = formatMeta(metaObj, getCodigoParaMeta(indicator)).replace('≤', '<=').replace('≥', '>=');
      }

      // Tendência
      let textoTendencia = '-';
      let colorTendencia = '475569';

      if (indicator.analise_periodo && indicator.analise_periodo.tendencia !== 'neutra') {
        const tend = indicator.analise_periodo;
        const isSubiu = tend.tendencia === 'subiu';

        const arrow = isSubiu ? '▲' : '▼';
        const trendColor = isSubiu ? colorGreen : colorRed;

        textoTendencia = `${arrow} ${Math.abs(tend.diferencaPercentual).toFixed(2)}%`;
        colorTendencia = trendColor;
      }

      const tableRows = [
        [
          { text: 'VALOR ATUAL', options: { fill: colorHeaderBg, color: '1E40AF', bold: true, fontSize: 11, align: 'center' } },
          { text: 'META', options: { fill: colorHeaderBg, color: '1E40AF', bold: true, fontSize: 11, align: 'center' } },
          { text: 'TENDÊNCIA (VS. MÊS ANTERIOR)', options: { fill: colorHeaderBg, color: '1E40AF', bold: true, fontSize: 11, align: 'center' } }
        ],
        [
          { text: textoValor, options: { color: valColor, fontSize: 14, bold: true, align: 'center' } },
          { text: textoMeta, options: { color: '1E40AF', fontSize: 14, bold: true, align: 'center' } },
          { text: textoTendencia, options: { color: colorTendencia, fontSize: 14, bold: true, align: 'center' } }
        ]
      ];

      slide.addTable(tableRows, {
        x: 0.5,
        y: currentY,
        w: 9.0,
        h: 0.8,
        colW: [3.0, 3.0, 3.0],
        border: { pt: 2, color: 'FFFFFF' },
        valign: 'middle'
      });

      currentY += 1.2;

      // GRÁFICO 
      const chartComponent = chartRefs.value[indicator.codigo];
      if (chartComponent && chartComponent.chart) {
        const imgData = chartComponent.chart.toBase64Image();

        const isDoughnut = getIndicatorMode(indicator.codigo) === 'doughnut';

        const chartW = isDoughnut ? 2.0 : 4.0;
        const chartH = 2.0;

        const chartX = (10 - chartW) / 2;

        slide.addImage({
          data: imgData,
          x: chartX,
          y: currentY,
          w: chartW,
          h: chartH,
          sizing: { type: 'contain', w: chartW, h: chartH }
        });

        if (getIndicatorMode(indicator.codigo) === 'doughnut') {
          let centerText = '';
          if (metaObj) {
            const pct = metaObj.valor > 0 ? (valAtual / metaObj.valor) * 100 : 0;
            centerText = pct.toFixed(0) + '%';
          } else {
            centerText = (valAtual?.toFixed(1) || '0.0') + '%';
          }

          // Ajuste de posição para alinhar com o novo centro e tamanho
          const centerY = currentY + (chartH / 2);
          const textY = centerY - 0.3;

          slide.addText(centerText, {
            x: chartX,
            y: textY,
            w: chartW,
            h: 0.5,
            fontSize: 18,
            bold: true,
            color: valColor,
            align: 'center'
          });

          slide.addText(metaObj ? "DA META" : "REALIZADO", {
            x: chartX,
            y: textY + 0.35,
            w: chartW,
            h: 0.3,
            fontSize: 9,
            color: '64748B',
            align: 'center'
          });
        }
      }
    }

    pptx.writeFile({ fileName: `Relatorio_Indicadores_${new Date().toISOString().slice(0, 10)}.pptx` });

  } catch (err) {
    console.error("Erro PPT:", err);
    alert("Erro ao gerar PowerPoint: " + err.message);
  } finally {
    isGeneratingPPT.value = false;
    await nextTick();
    Object.values(chartRefs.value).forEach(c => c && c.chart && c.chart.update());
  }
};

function calculateAggregateData(dadosFiltrados) {
  if (!dadosFiltrados || dadosFiltrados.length === 0) {
    return {
      numeradorTotal: 0,
      denominadorTotal: 0,
      valorPercentual: 0
    };
  }

  const numeradorTotal = dadosFiltrados.reduce((acc, item) =>
    acc + parseFloat(item.numerador || 0), 0);

  const denominadorTotal = dadosFiltrados.reduce((acc, item) =>
    acc + parseFloat(item.denominador || 0), 0);

  const valorPercentual = denominadorTotal > 0
    ? (numeradorTotal / denominadorTotal) * 100
    : 0;

  return {
    numeradorTotal: numeradorTotal,
    denominadorTotal: denominadorTotal,
    valorPercentual: valorPercentual
  };
}

function calculatePeriodAnalysis(grupo) {
  if (!grupo || !grupo.indicadores || grupo.indicadores.length === 0) {
    return { ...grupo, analise_periodo: null };
  }

  const dadosIndicador = grupo.indicadores[0].dados;
  const dadosFiltrados = applyDateRangeFilter(dadosIndicador);
  const dadosAgregados = calculateAggregateData(dadosFiltrados);

  if (dadosFiltrados.length < 2) {
    return {
      ...grupo,
      analise_periodo: {
        agregado: dadosAgregados,
        mesInicial: null, mesFinal: null, diferencaAbsoluta: 0,
        diferencaPercentual: 0, tendencia: 'neutra',
        valorUltimo: dadosAgregados.valorPercentual,
        numeradorUltimo: dadosAgregados.numeradorTotal,
        denominadorUltimo: dadosAgregados.denominadorTotal,
      }
    };
  }

  const penultimo = dadosFiltrados[dadosFiltrados.length - 2];
  const ultimo = dadosFiltrados[dadosFiltrados.length - 1];

  const numPenultimo = parseFloat(penultimo.numerador || 0);
  const numUltimo = parseFloat(ultimo.numerador || 0);

  const valPenultimo = parseFloat(penultimo.valor);
  const valUltimo = parseFloat(ultimo.valor);

  // Cálculos baseados na diferença entre o último e o penúltimo mês
  const difAbsoluta = numUltimo - numPenultimo;
  const difPercentual = valUltimo - valPenultimo;

  let tendencia = 'neutra';
  if (difPercentual > 0.01) tendencia = 'subiu';
  if (difPercentual < -0.01) tendencia = 'desceu';

  return {
    ...grupo,
    analise_periodo: {
      mesInicial: penultimo.titulo,
      mesFinal: ultimo.titulo,
      diferencaAbsoluta: difAbsoluta,
      diferencaPercentual: difPercentual,
      tendencia: tendencia,
      valorUltimo: valUltimo,
      numeradorUltimo: numUltimo,
      denominadorUltimo: parseFloat(ultimo.denominador),
      agregado: dadosAgregados
    }
  };
}

// Pega TODOS os dados (Ignora o filtro de data global) 
function getAllMonthsData(indicator) {
  if (!indicator?.indicadores?.[0]?.dados) return [];

  // Apenas remove o 'SET'. NÃO aplica applyDateRangeFilter.
  return indicator.indicadores[0].dados.filter(d => d.titulo !== 'SET');
}

// Pega o objeto de dados do mês selecionado (para o Gráfico)
function getSelectedMonthData(indicator) {
  // Agora busca na lista completa de meses
  const data = getAllMonthsData(indicator);

  if (data.length === 0) return null;

  const selectedIndex = doughnutSelections.value[indicator.codigo];

  if (selectedIndex !== undefined && data[selectedIndex]) {
    return data[selectedIndex];
  }

  // Último mês da lista
  return data[data.length - 1];
}

function navigateDoughnut(indicator, direction) {
  const data = getAllMonthsData(indicator);

  if (data.length === 0) return;

  let currentIndex = doughnutSelections.value[indicator.codigo];

  if (currentIndex === undefined) {
    currentIndex = data.length - 1;
  }

  const newIndex = currentIndex + direction;

  if (newIndex >= 0 && newIndex < data.length) {
    doughnutSelections.value = {
      ...doughnutSelections.value,
      [indicator.codigo]: newIndex
    };
  }
}

function getDoughnutValue(indicator) {
  const data = getSelectedMonthData(indicator);
  if (!data) return null;
  const val = parseFloat(data.valor);
  return !isNaN(val) ? val : null;
}

// Função auxiliar para definir a cor do texto no Gráfico de Rosca 
function getDoughnutTextColorClass(indicator) {
  const codigoParaMeta = getCodigoParaMeta(indicator);
  const meta = getMeta(codigoParaMeta);

  if (!meta) return 'text-blue-600 dark:text-blue-400';

  const valorAtual = getDoughnutValue(indicator);

  // Recalcula meta atingida para este mês específico
  const metaAtingida = verificaMetaAtingida(valorAtual, meta.valor, meta.operador);
  const pct = meta.valor > 0 ? (valorAtual / meta.valor) * 100 : 0;

  if (meta.operador === '>' || meta.operador === '>=') {
    if (metaAtingida) return 'text-green-500 dark:text-green-400';
    else if (pct >= 70) return 'text-yellow-500 dark:text-yellow-400';
    else return 'text-red-500 dark:text-red-400';
  } else {
    if (!metaAtingida) return 'text-red-500 dark:text-red-400';
    else if (pct >= 70) return 'text-yellow-500 dark:text-yellow-400';
    else return 'text-green-500 dark:text-green-400';
  }
}

// Função auxiliar para normalizar strings (remover acentos)
function normalizeString(str) {
  if (!str) return '';
  return str
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();
}

const filteredIndicators = computed(() => {
  // Os filtros de tipo e unidade já são aplicados no backend
  // Aqui apenas aplicamos o filtro de busca (search) que é feito no frontend
  const todosIndicadores = indicators.value;
  let itemsFiltrados = [...todosIndicadores];

  const query = searchQuery.value ? normalizeString(searchQuery.value) : '';

  if (query) {
    const isAvancadasFilterActive = activeTypeFilter.value === 'Avançadas';

    itemsFiltrados = itemsFiltrados.filter(grupo => {
      const titulo = normalizeString(getIndicatorTitle(grupo.codigo));
      const descricao = normalizeString(getIndicatorDescription(grupo.codigo));
      const nomeUnidade = normalizeString(grupo.indicadores[0]?.unidade_nome || '');

      // Busca no título, descrição ou unidade
      const matchTitulo = titulo.includes(query);
      const matchDescricao = descricao && descricao.includes(query);
      const matchUnidade = isAvancadasFilterActive && nomeUnidade && nomeUnidade.includes(query);

      return matchTitulo || matchDescricao || matchUnidade;
    });
  }

  return itemsFiltrados.sort((a, b) => {
    const keysA = getIndicatorSortKeys(a.codigo);
    const keysB = getIndicatorSortKeys(b.codigo);

    if (keysA.vNum !== keysB.vNum) {
      return keysA.vNum - keysB.vNum;
    }
    return keysA.iNum - keysB.iNum;
  });
});

const setIndicatorMode = (codigo, mode) => {
  indicatorsStore.setChartMode(codigo, mode);
};

const getIndicatorMode = (codigo) => {
  if (indicatorsStore.chartModes && indicatorsStore.chartModes[codigo]) {
    return indicatorsStore.chartModes[codigo];
  }

  return 'line';
};

const reportMode = computed({
  get: () => indicatorsStore.reportMode || 'ambos',
  set: (val) => indicatorsStore.setReportMode(val)
});

function openDateFilterModal() {
  localDateFilter.value = { ...activeDateFilter.value };
  showDateFilterModal.value = true;
}

function closeDateFilterModal() {
  showDateFilterModal.value = false;
}

function applyDateFilter() {
  indicatorsStore.setDateFilter(localDateFilter.value);
  closeDateFilterModal();
}

function clearFilters() {
  activeUnitFilter.value = '';
  searchQuery.value = '';

  const emptyDateFilter = {
    granularity: 'mensal',
    startYear: '',
    startMonth: '',
    endYear: '',
    endMonth: '',
    startDate: '',
    endDate: ''
  };

  indicatorsStore.setDateFilter(emptyDateFilter);
  localDateFilter.value = { ...emptyDateFilter };
}

// Importações do Chart.js
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
} from 'chart.js'
import { Line, Doughnut, Bar } from 'vue-chartjs'

// Registrar componentes do Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  ChartDataLabels
)

import {
  ArrowDownIcon, ArrowUpIcon,
  SearchIcon,
  Maximize2Icon,
  Minimize2Icon,
  Filter, Icon,
  LineChart, BarChart3, PieChart,
  PencilIcon, CheckIcon, XIcon,
  Activity
} from 'lucide-vue-next';
import { broom } from '@lucide/lab';

const currentView = ref('overview');
const isKioskMode = ref(false);
const currentTime = ref('');
const currentDate = ref('');

const chartRefs = ref({});

const currentPage = ref(0);
const cardsPerPage = ref(6);
const REFRESH_INTERVAL = 86400000; // 24 horas
const VIEW_ROTATION_INTERVAL = 30000;

let refreshTimer = null;
let viewRotationTimer = null;
let timeUpdateTimer = null;

const showDateFilterModal = ref(false);

watch(showDateFilterModal, (isOpen) => {
  if (isOpen) {
    const storeDate = indicatorsStore.filters.date;
    localDateFilter.value = {
      granularity: storeDate.granularity || 'mensal',
      startYear: storeDate.startYear || '',
      startMonth: storeDate.startMonth || '',
      endYear: storeDate.endYear || '',
      endMonth: storeDate.endMonth || '',
      startDate: storeDate.startDate || '',
      endDate: storeDate.endDate || ''
    };
  }
});

const localDateFilter = ref({
  granularity: 'mensal', // 'mensal', 'semanal', 'diario'
  startYear: '',
  startMonth: '',
  endYear: '',
  endMonth: '',
  startDate: '', // Para semanal/diário
  endDate: ''    // Para semanal/diário
});

const monthOptions = ref([
  { value: 1, name: 'Janeiro' },
  { value: 2, name: 'Fevereiro' },
  { value: 3, name: 'Março' },
  { value: 4, name: 'Abril' },
  { value: 5, name: 'Maio' },
  { value: 6, name: 'Junho' },
  { value: 7, name: 'Julho' },
  { value: 8, name: 'Agosto' },
  { value: 9, name: 'Setembro' },
  { value: 10, name: 'Outubro' },
  { value: 11, name: 'Novembro' },
  { value: 12, name: 'Dezembro' }
]);

const granularityOptions = [
  { value: 'mensal', label: 'Mensal' },
  { value: 'semanal', label: 'Semanal' },
  { value: 'diario', label: 'Diário' }
];



// Adiciona o ano atual (2026) se não estiver presente
const availableDataYears = computed(() => {
  const yearsSet = new Set();
  yearsSet.add(new Date().getFullYear()); // Garante o ano atual (2026)

  indicatorsRawData.value.forEach(grupo => {
    const dados = grupo.indicadores[0]?.dados || [];
    dados.forEach(item => {
      if (item.titulo && item.titulo.includes('/')) {
        const ano = parseInt(item.titulo.split('/')[0]);
        if (!isNaN(ano)) yearsSet.add(ano);
      }
    });
  });

  if (yearsSet.size === 0) return [new Date().getFullYear()];

  return Array.from(yearsSet).sort((a, b) => a - b);
});

const startYearOptions = computed(() => availableDataYears.value);

const endYearOptions = computed(() => {
  const startY = localDateFilter.value.startYear;
  if (!startY) return availableDataYears.value;

  return availableDataYears.value.filter(year => year >= startY);
});

const endMonthOptions = computed(() => {
  const startY = localDateFilter.value.startYear;
  const endY = localDateFilter.value.endYear;
  const startM = localDateFilter.value.startMonth;

  if (!startY || !endY || startY !== endY) {
    return monthOptions.value;
  }

  if (startM) {
    return monthOptions.value.filter(m => m.value >= startM);
  }

  return monthOptions.value;
});

const activeTypeFilter = computed({
  get: () => indicatorsStore.filters.type,
  set: (val) => indicatorsStore.setFilter('type', val)
});

const activeUnitFilter = computed({
  get: () => indicatorsStore.filters.unit,
  set: (val) => indicatorsStore.setFilter('unit', val)
});

// Variável local para busca no frontend
const searchQuery = ref(indicatorsStore.filters.search || '');

const saveChartRef = (el, codigo) => {
  if (el) {
    chartRefs.value[codigo] = el;
  }
};

// Sincronizar com o store quando mudar
watch(searchQuery, (newValue) => {
  indicatorsStore.setFilter('search', newValue);
});

// Sincronizar quando o store mudar
watch(() => indicatorsStore.filters.search, (newValue) => {
  if (searchQuery.value !== newValue) {
    searchQuery.value = newValue || '';
  }
});

const activeDateFilter = computed(() => indicatorsStore.filters.date);

watch(() => localDateFilter.value.startYear, (newStartYear) => {
  if (localDateFilter.value.endYear && newStartYear > localDateFilter.value.endYear) {
    localDateFilter.value.endYear = '';
    localDateFilter.value.endMonth = '';
  }
});

watch(() => localDateFilter.value.startMonth, (newStartMonth) => {
  const f = localDateFilter.value;
  if (f.startYear === f.endYear && f.endMonth && newStartMonth > f.endMonth) {
    localDateFilter.value.endMonth = '';
  }
});

const isUnitFilterActive = computed(() => {
  return !!activeUnitFilter.value;
});

const isDateFilterActive = computed(() => {
  const f = activeDateFilter.value;
  if (f.granularity === 'mensal' || !f.granularity) {
    return !!f.startYear || !!f.endYear;
  }
  return !!f.startDate || !!f.endDate;
});

const lineChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: {
      top: 30,
      right: 30,
      left: 0,
      bottom: 0
    }
  },
  plugins: {
    legend: { display: false },
    tooltip: {
      callbacks: {
        label: function (context) {
          let label = context.dataset.label || '';
          let value = context.parsed.y;
          if (label) { label += ': '; }
          label += value.toFixed(2) + '%';
          return label;
        }
      }
    },
    datalabels: {
      display: true,
      color: function (context) {
        // 1. Verificar validação básica de dados
        if (!context || !context.parsed || context.parsed.y === undefined || isNaN(context.parsed.y)) {
          return getChartColor('rgba(147, 197, 253, 1)', 'rgb(107, 114, 128)');
        }

        // 2. Lógica de Meta (Verde/Vermelho)
        const dataset = context.dataset;
        const value = context.parsed.y;
        const metaValor = dataset && dataset.metaValue;
        const metaOperador = dataset && dataset.metaOperador;

        if (metaValor !== undefined && metaValor !== null && !isNaN(metaValor) && metaOperador) {
          const metaAtingida = verificaMetaAtingida(value, metaValor, metaOperador);
          return metaAtingida === true
            ? 'rgba(34, 197, 94, 1)' // Verde
            : 'rgba(239, 68, 68, 1)'; // Vermelho
        }

        // 3. Cor padrão caso tenha dados mas não tenha meta
        return getChartColor('rgba(147, 197, 253, 1)', 'rgb(107, 114, 128)');
      },
      font: function (context) {
        const count = context.chart.data.labels.length;
        const size = count <= 9 ? 15 : 12;

        return {
          size: size,
          weight: 'bold'
        };
      },
      formatter: function (value) {
        if (value === null || value === undefined) return '';
        return parseFloat(value).toFixed(2) + '%';
      },
      anchor: 'end',
      align: 'end',
      offset: 0,
      clip: false
    }
  },
  scales: {
    x: {
      ticks: { color: 'rgba(107, 114, 128)' },
      grid: { color: 'rgba(0, 0, 0, 0.05)' }
    },
    y: {
      ticks: {
        color: () => getChartColor('rgba(107, 114, 128, 0.7)', 'rgba(107, 114, 128, 0.4)')
      },
      grid: { color: 'rgba(0, 0, 0, 0.05)' },
      min: 0,
      suggestedMax: 50,
      grace: '10%'
    }
  }
};

const kioskLineChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: {
      callbacks: {
        label: function (context) {
          let label = context.dataset.label || '';
          let value = context.parsed.y;
          if (label) { label += ': '; }
          label += value.toFixed(2) + '%';
          return label;
        }
      }
    },
    datalabels: {
      enabled: true,
      display: true,
      color: function (context) {
        // Verificar se context.parsed existe
        if (!context || !context.parsed || context.parsed.y === undefined || isNaN(context.parsed.y)) {
          return 'rgba(147, 197, 253, 1)'; // Azul claro para kiosk se não houver dados
        }

        const dataset = context.dataset;
        const value = context.parsed.y;
        const metaValor = dataset && dataset.metaValue;
        const metaOperador = dataset && dataset.metaOperador;

        if (metaValor !== undefined && metaValor !== null && !isNaN(metaValor) && metaOperador) {
          const metaAtingida = verificaMetaAtingida(value, metaValor, metaOperador);
          return metaAtingida === true
            ? 'rgba(34, 197, 94, 1)' // Verde se meta atingida
            : 'rgba(239, 68, 68, 1)'; // Vermelho se meta não atingida
        }
        return 'rgba(147, 197, 253, 1)'; // Azul claro para kiosk
      },
      font: function (context) {
        const count = context.chart.data.labels.length;
        // Se tiver muitos dados, usa fonte 12 para não poluir
        const size = count <= 9 ? 15 : 12;

        return {
          size: size,
          weight: 'bold'
        };
      },
      formatter: function (value) {
        if (value === null || value === undefined || isNaN(value)) {
          return '';
        }
        return value.toFixed(2) + '%';
      },
      anchor: 'end',
      align: 'end',
      offset: 6,
      clip: false
    }
  },
  scales: {
    x: {
      ticks: { color: 'rgb(156, 163, 175)' },
      grid: { color: 'rgba(255, 255, 255, 0.1)' }
    },
    y: {
      ticks: { color: 'rgba(156, 163, 175, 0.5)' },
      grid: { color: 'rgba(255, 255, 255, 0.1)' },
      min: 0,
      suggestedMax: 50,
      grace: '20%'
    }
  }
};

const barChartOptions = {
  plugins: {
    legend: { display: false },
    datalabels: {
      display: true,
      color: function () {
        return getChartColor('rgba(147, 197, 253, 1)', 'rgb(107, 114, 128)');
      },
      anchor: 'end',
      align: 'end',
      offset: 0,
      font: function (context) {
        const count = context.chart.data.labels.length;
        // Se tiver muitos dados, usa fonte 12 para não poluir
        const size = count <= 9 ? 15 : 12;

        return {
          size: size,
          weight: 'bold'
        };
      },
      formatter: function (value) {
        // Formata o valor com 2 casas decimais e o símbolo %
        if (value === null || value === undefined) return '';
        return parseFloat(value).toFixed(2) + '%';
      }
    }
  },
  responsive: true,
  maintainAspectRatio: false,

  scales: {
    x: {
      grid: { display: false },
      ticks: { color: 'rgb(107, 114, 128)' }
    },
    y: {
      ticks: {
        color: () => getChartColor('rgba(107, 114, 128, 0.7)', 'rgba(107, 114, 128, 0.4)')
      },
      grid: { color: 'rgba(0, 0, 0, 0.05)' },
      min: 0,
      suggestedMax: 50,
      grace: '10%'
    }
  }
};

const kioskBarChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    datalabels: {
      display: true,
      color: 'rgba(147, 197, 253, 1)',
      anchor: 'end',
      align: 'end',
      offset: 0,
      font: function (context) {
        const count = context.chart.data.labels.length;
        const size = count <= 9 ? 15 : 12;

        return {
          size: size,
          weight: 'bold'
        };
      },
      formatter: function (value) {
        if (value === null || value === undefined) return '';
        return parseFloat(value).toFixed(2) + '%';
      }
    },
    tooltip: {
      callbacks: {
        label: function (context) {
          let label = context.dataset.label || '';
          let value = context.parsed.y;
          if (label) { label += ': '; }
          label += value.toFixed(2) + '%';
          return label;
        }
      }
    }
  },
  scales: {
    x: {
      grid: { display: false },
      ticks: { color: 'rgb(156, 163, 175)' }
    },
    y: {
      ticks: { color: 'rgba(156, 163, 175, 0.5)' },
      grid: { color: 'rgba(255, 255, 255, 0.1)' },
      min: 0,
      suggestedMax: 50,
      grace: '10%'
    }
  }
};

const doughnutChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  animation: {
    animateScale: true,
    animateRotate: true
  },
  plugins: {
    legend: {
      display: false
    },
    datalabels: {
      display: false
    },
    tooltip: {
      enabled: true,
      callbacks: {
        label: function (context) {
          const dataset = context.dataset;
          const index = context.dataIndex;

          // Se for a parte "cheia"
          if (index === 0) {
            const val = dataset.originalValue || context.parsed;
            return `Realizado: ${val.toLocaleString('pt-BR')}`;
          }
          // Se for a parte "vazia"
          return '';
        }
      },
      filter: function (tooltipItem) {
        return tooltipItem.dataIndex === 0;
      }
    }
  }
};

const updateTime = () => {
  const now = new Date()
  currentTime.value = now.toLocaleTimeString('pt-BR')
  currentDate.value = now.toLocaleDateString('pt-BR', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}

const setActiveTypeFilter = (typeFilter) => {
  activeTypeFilter.value = typeFilter;
  if (typeFilter === 'CCDTI') {
    activeUnitFilter.value = '';
  }
};

// Watchers para disparar nova consulta quando os filtros mudarem
watch(() => activeTypeFilter.value, () => {
  fetchIndicators();
  // Atualizar lista de unidades quando o tipo mudar
  if (activeTypeFilter.value === 'Avançadas') {
    fetchAvailableUnits();
  } else {
    availableUnits.value = [];
  }
});

watch(() => activeUnitFilter.value, () => {
  // Só buscar novamente se o tipo for Avançadas
  if (activeTypeFilter.value === 'Avançadas') {
    fetchIndicators();
  }
});

onMounted(() => {
  updateTime();
  timeUpdateTimer = setInterval(updateTime, 1000);

  fetchIndicators();
  // Buscar unidades disponíveis se o tipo for Avançadas
  if (activeTypeFilter.value === 'Avançadas') {
    fetchAvailableUnits();
  }
});

const toggleKioskMode = () => {
  isKioskMode.value = !isKioskMode.value;
  if (isKioskMode.value) {
    startKioskMode();
  } else {
    stopKioskMode();
  }
};

const startKioskMode = () => {
  currentPage.value = 0;

  if (refreshTimer) {
    clearInterval(refreshTimer);
  }
  if (viewRotationTimer) {
    clearInterval(viewRotationTimer);
  }

  refreshTimer = setInterval(async () => {
    await fetchIndicators();
  }, REFRESH_INTERVAL);

  viewRotationTimer = setInterval(() => {
    if (totalIndicatorPages.value > 0) {
      const nextPageIndex = (currentPage.value + 1);
      if (nextPageIndex >= totalIndicatorPages.value) {
        currentPage.value = 0;
      } else {
        currentPage.value = nextPageIndex;
      }
    } else {
      currentPage.value = 0;
    }
  }, VIEW_ROTATION_INTERVAL);

  const element = document.documentElement;
  if (element && element.requestFullscreen && !document.fullscreenElement) {
    element.requestFullscreen().catch(() => { });
  }
};

const stopKioskMode = () => {
  if (refreshTimer) {
    clearInterval(refreshTimer);
    refreshTimer = null;
  }
  if (viewRotationTimer) {
    clearInterval(viewRotationTimer);
    viewRotationTimer = null;
  }

  if (document.fullscreenElement && document.exitFullscreen) {
    document.exitFullscreen().catch(() => { });
  }
};

onUnmounted(() => {
  stopKioskMode();
  if (timeUpdateTimer) {
    clearInterval(timeUpdateTimer);
  }
});

const kioskTitle = computed(() => {
  if (activeTypeFilter.value === 'CCDTI') {
    return 'Painel de Indicadores - CCDTI';
  }
  if (activeTypeFilter.value === 'Avançadas') {
    return 'Painel de Indicadores - Avançadas';
  }
  return 'Painel de Indicadores';
});

const totalIndicatorPages = computed(() => {
  if (filteredIndicators.value.length === 0) return 1;
  return Math.ceil(filteredIndicators.value.length / cardsPerPage.value);
});

const currentPageIndicators = computed(() => {
  if (!isKioskMode.value) {
    return filteredIndicators.value;
  }

  const start = currentPage.value * cardsPerPage.value;
  const end = start + cardsPerPage.value;
  return filteredIndicators.value.slice(start, end);
});

</script>
